<!-- eslint-disable vue/no-parsing-error -->
<template>
  <!-- skeleton -->
  <PlaySkeleton :show="secondContentLoading" />

  <div
    :class="['play-wrapper', showBackNavarBar ? '' : 'over-page']"
    v-show="!secondContentLoading"
  >
    <van-nav-bar
      :title="item.name"
      @click-left="onClickLeft"
      v-if="
        showTitleNavbar &&
        (backUrl ||
          (theme != 'THEME_MS' &&
            !theme?.startsWith('PLATFORM_ID_') &&
            showBackNavarBar))
      "
      class="sticky-navbar"
      z-index="999"
    >
      <template #left>
        <van-icon
          class="arrow-left"
          name="arrow-left"
          size="20"
          color="#323233"
        />
      </template>
    </van-nav-bar>
    <div
      class="float-navbar"
      v-if="
        !showTitleNavbar &&
        (backUrl ||
          (theme != 'THEME_MS' &&
            !theme?.startsWith('PLATFORM_ID_') &&
            showBackNavarBar))
      "
      @click="onClickLeft"
    >
      <img src="@/assets/H5/play/arrow-left.png" class="left-img" />
    </div>

    <div>
      <!-- video -->
      <div
        class="video-box"
        v-show="
          (thisContentType === 2 && isVideo) ||
          (prevTab === 2 && isVideo && haveVideo)
        "
      >
        <div class="score-top-tip flex flex-j-b flex-a-c" v-show="showScoreTip">
          <div class="box flex flex-a-c">
            <div class="tip">{{ scoreTip }}</div>
            <div class="btn">
              <van-button
                plain
                round
                color="#ffffff"
                block
                size="mini"
                @click="toScoreCenter"
                >查看</van-button
              >
            </div>
          </div>
          <div class="close" @click="showScoreTip = false">
            <van-icon name="cross" color="#fff" />
          </div>
        </div>
        <div class="video-wrap">
          <Xg-Player
            v-show="course.content"
            :id="'xgPlayer'"
            width="100%"
            height="100%"
            v-model:datas="course"
            @timeupdate="timeupdateVideo"
            @pause="pause"
            @ended="ended"
            @navbar="scrollNavbar"
            :isCanLook="isCanLook"
            :ggList="videoGgList"
            @closeGg="closeVideoGg"
            @toGg="toVideoGg"
            :freeTime="freeTime"
            :_showShiKanFlag="showShiKanFlag"
            :collectFeeStatus="collectFeeStatus"
            :_showInfo1="showInfo1_video"
            :_showInfo2="showInfo2_video"
            :_showInfo3="showInfo3_video"
            :_showApplyInfo2="showInfo4_video"
            :_showInfo5="showInfo5_video"
            :phone="phone"
            @tosureInfo="sureInfo_video"
            @toBindPhone="toBindPhone"
            :_namStr="namStr_video"
            :_myTrainerName="myTrainerName"
            :_applyStatus="applyStatus"
            @showNavarBar="showNavarBar"
            :showRecommend="showRecommend"
            :nextPlayTime="nextPlayTime"
            :recommendList="recommendList"
            @playRecommend="playRecommend"
            @replay="handleReplay"
            :disableProgress="disableProgress"
          />
          <!-- :clickSectionTime="clickSectionTime" -->
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            :src="videoBanner"
            v-show="!course.content"
          />
          <!-- 转发分享层 -->
          <div class="share-box" v-if="openShare && !myIsShare">
            <div class="text text1">转发分享，和朋友一起免费学</div>
            <div class="text text2">
              <div class="t1">1.点击右上角</div>
              <div class="t2">
                2.点击<span class="py"></span>或<span class="pyq"></span>分享
              </div>
            </div>
            <div class="jiantou"></div>
          </div>
          <!-- 推荐层 -->
          <!-- <div class="recommend-pop" v-if="showRecommend">
            <div class="next-play-tip">即将播放下一个：{{ nextPlayTime }}s</div>
            <div class="next-play-list">
              <div class="next-play-item">
                <div class="next-play-banner">
                  <img src="" alt="" class="next-play-banner--img" />
                </div>
                <div class="next-play-title ellipsis">
                  视频哇偶啊我iu嗷呜哦啊我修啊我iu啊我iu
                </div>
              </div>
              <div class="next-play-item">
                <div class="next-play-banner">
                  <img src="" alt="" class="next-play-banner--img" />
                </div>
                <div class="next-play-title ellipsis">视频2</div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="content">
          <div class="hj-share-btn" v-if="syncFlag" @click="toShare">
            <div class="icon"></div>
            <div class="text">分享给患者</div>
          </div>
          <div class="title py-1 flex-j-b">
            <div class="text van-multi-ellipsis--l2">
              {{ secondSpecialName }}
            </div>
            <div
              v-if="isKc"
              :class="`sc flex-j-a ${isCollect ? 'active' : ''}`"
              @click="onSC"
            >
              <div class="icon"></div>
              <div class="sc-text">{{ isCollect ? "已收藏" : "收藏" }}</div>
            </div>
          </div>
          <div class="zhuanjia-box flex" v-if="author">
            <div class="img" @click="toJiangshi(author.userId)">
              <van-image fit="contain" :src="author.imageUrl" />
            </div>
            <div class="word">
              <div class="name" @click="showZhuanjia">
                {{ author.name }}<span>{{ author.jobTitles[0] }}</span>
              </div>
              <div
                class="detail"
                :style="`height:${
                  showZjAll ? 'auto' : '4.53333vw'
                };padding-right:${showZjAll ? '60px' : '100px'}`"
              >
                <div class="icon flex flex-a-c" @click="showZhuanjia">
                  <div class="word">{{ showZjAll ? "收起" : "详情" }}</div>
                  <img
                    v-if="showZjAll"
                    src="@/assets/H5/play/arrow_up_blue.png"
                    alt=""
                    class="icon-box"
                  />
                  <img
                    v-else
                    src="@/assets/H5/play/arrow_down_blue.png"
                    alt=""
                    class="icon-box"
                  />
                </div>
                <div @click="showZhuanjia">
                  <div
                    :class="`w-item ${showZjAll ? '' : 'van-ellipsis'}`"
                    v-for="(items, d) in author.listSecondPosition"
                    :key="d"
                  >
                    {{ items }}
                  </div>
                </div>
                <div
                  class="to-home-page"
                  :class="{
                    mt8:
                      author.listSecondPosition &&
                      author.listSecondPosition.length,
                  }"
                  @click="toJiangshi(author.userId)"
                >
                  <div class="to-text">前往讲师主页</div>
                  <img
                    src="@/assets/H5/play/arrow_right_blue.png"
                    alt=""
                    class="arrow_right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 直播 -->
      <div
        class="zhibo-box"
        v-show="
          (thisContentType === 1 && isLive) ||
          (prevTab === 1 && isLive && haveVideo)
        "
      >
        <div class="zb-box-con">
          <div class="zhibo-wrap">
            <!-- 阿里直播 -->
            <template v-if="activeLive.liveType == 1">
              <Ali-Player
                :canAppoint="canAppoint"
                :source="activeLive.content"
                :isLive="activeLive.content.includes('.mp4') ? false : true"
                :cover="item.bannerH5 || item.banner"
                @canPlay="aliPlayerCanPlay"
                :liveStartTime="zbyyTime"
              />
            </template>
            <template v-else>
              <iframe
                id="zhiboIframe"
                :src="activeLive.content"
                style="width: 100%; height: 100%; overflow: hidden"
                scrolling="no"
                allowfullscreen=""
              >
              </iframe>
            </template>
            <!-- 广告 -->
            <transition name="fade">
              <div v-if="ggList.length">
                <template v-for="(gg, i) in ggList">
                  <div
                    :key="i"
                    :class="`gg-item gg-item-${gg.advertId}-${gg.id} ${
                      gg.perpendicularDistance == -1 ||
                      gg.horizontalDistance == -1
                        ? 'wz-center'
                        : gg.perpendicularDistance == -2 ||
                          gg.horizontalDistance == -2
                        ? 'wz-b-center'
                        : ''
                    }`"
                    :style="
                      gg.perpendicularDistance >= 0 &&
                      gg.horizontalDistance >= 0
                        ? `top:${gg.perpendicularDistance}%;left:${gg.horizontalDistance}%;`
                        : ''
                    "
                    v-if="gg.showGgitem == true && gg.pictureH5"
                  >
                    <div
                      class="close-gg"
                      v-if="gg.typeFlag == '0'"
                      @click="closeGg(gg, 1)"
                    >
                      <van-image
                        width="18"
                        height="18"
                        fit="scale-down"
                        :src="require('@/assets/H5/score/close.png')"
                      />
                    </div>
                    <div class="gg-img">
                      <van-image
                        width="100%"
                        height="100%"
                        object-fit="contain"
                        @click="toLink(gg, 1)"
                        :src="gg.pictureH5 ? gg.pictureH5 : ''"
                      />
                    </div>
                  </div>
                </template>
              </div>
            </transition>
          </div>
          <!-- 预约提示 -->
          <div class="time-tip" v-if="showTimeFlag">
            <div class="tip1">
              距离<span>{{ zbyyTime }}</span
              >直播开始还有
            </div>
            <div class="tip2" v-html="showTime"></div>
            <div class="tip-btn" v-if="!zbyyStatus">
              <van-button
                round
                block
                color="#0F3CC6"
                type="success"
                @click="toYyzhibo"
                >立即预约</van-button
              >
            </div>
            <div class="tip-btn-over" v-if="zbyyStatus">
              <van-button round block color="#ffffff" type="success"
                >已预约</van-button
              >
            </div>
            <div class="tip3" v-if="zbyyStatus">
              开播前10分钟将会通过短信或公众号提醒您
            </div>
          </div>
          <!-- 转发分享层 -->
          <div class="share-box" v-if="openShare && !myIsShare">
            <div class="text text1">转发分享，和朋友一起免费学</div>
            <div class="text text2">
              <div class="t1">1.点击右上角</div>
              <div class="t2">
                2.点击<span class="py"></span>或<span class="pyq"></span>分享
              </div>
            </div>
            <div class="jiantou"></div>
          </div>
        </div>
        <div class="content">
          <div class="title py-1 van-multi-ellipsis--l2 flex-j-b flex-a-c">
            <span>{{ secondSpecialName }}</span>
          </div>
          <div class="question-btn" v-if="showQuestion">
            <van-button
              round
              block
              color="#0F3CC6"
              type="success"
              @click="toQuestion"
              >会后问答</van-button
            >
          </div>
          <div class="zhuanjia-box flex" v-if="author">
            <div class="img" @click="toJiangshi(author.userId)">
              <van-image
                width="40px"
                height="40px"
                fit="contain"
                :src="author.imageUrl"
              />
            </div>
            <div class="word">
              <div class="name" @click="showZhuanjia">
                {{ author.name }}<span>{{ author.jobTitles[0] }}</span>
              </div>
              <div
                class="detail"
                :style="`height:${showZjAll ? 'auto' : '17px'};padding-right:${
                  showZjAll ? '60px' : '100px'
                }`"
              >
                <div class="icon flex flex-a-c" @click="showZhuanjia">
                  <!-- <div class="word">{{ showZjAll ? "收起" : "详情" }}</div>
                  <van-icon
                    color="#0f3cc6"
                    size="16px"
                    :name="`${showZjAll ? 'arrow-up' : 'arrow-down'}`"
                  /> -->
                  <div class="word">{{ showZjAll ? "收起" : "详情" }}</div>
                  <img
                    v-if="showZjAll"
                    src="@/assets/H5/play/arrow_up_blue.png"
                    alt=""
                    class="icon-box"
                  />
                  <img
                    v-else
                    src="@/assets/H5/play/arrow_down_blue.png"
                    alt=""
                    class="icon-box"
                  />
                </div>
                <div @click="showZhuanjia">
                  <div
                    :class="`w-item ${showZjAll ? '' : 'van-ellipsis'}`"
                    v-for="(items, d) in author.listSecondPosition"
                    :key="d"
                  >
                    {{ items }}
                  </div>
                </div>
                <div
                  class="to-home-page"
                  :class="{
                    mt8:
                      author.listSecondPosition &&
                      author.listSecondPosition.length,
                  }"
                  @click="toJiangshi(author.userId)"
                >
                  <div class="to-text">前往讲师主页</div>
                  <img
                    src="@/assets/H5/play/arrow_right_blue.png"
                    alt=""
                    class="arrow_right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-image
        v-show="thisContentType === 1 && !isLive"
        width="100%"
        fit="contain"
        :src="item.bannerH5 || item.banner"
      />
      <!-- banner -->
      <div
        class="banner u-real"
        v-show="
          thisContentType != 1 && thisContentType != 2 && !isVideo && !isLive
        "
      >
        <van-image
          width="100%"
          fit="contain"
          :src="item.bannerH5 ? item.bannerH5 : item.banner"
        />
        <div class="content">
          <div class="title py-1 van-multi-ellipsis--l2">
            {{ item.name }}
          </div>
          <div class="learn-count flex-j-b flex-a-c">
            <div class="van-ellipsis">{{ item.title }}</div>
          </div>
          <div class="zhuanjia-box flex" v-if="author">
            <div class="img" @click="toJiangshi(author.userId)">
              <van-image
                width="40px"
                height="40px"
                fit="contain"
                :src="author.imageUrl"
              />
            </div>
            <div class="word">
              <div class="name" @click="showZhuanjia">
                {{ author.name }}<span>{{ author.jobTitles[0] }}</span>
              </div>
              <div
                class="detail"
                :style="`height:${showZjAll ? 'auto' : '17px'};padding-right:${
                  showZjAll ? '60px' : '100px'
                }`"
              >
                <div class="icon flex flex-a-c" @click="showZhuanjia">
                  <div class="word">{{ showZjAll ? "收起" : "详情" }}</div>
                  <img
                    v-if="showZjAll"
                    src="@/assets/H5/play/arrow_up_blue.png"
                    alt=""
                    class="icon-box"
                  />
                  <img
                    v-else
                    src="@/assets/H5/play/arrow_down_blue.png"
                    alt=""
                    class="icon-box"
                  />
                  <!-- <div class="word">{{ showZjAll ? "收起" : "详情" }}</div>
                  <van-icon
                    color="#0f3cc6"
                    size="12px"
                    :name="`${showZjAll ? 'arrow-up' : 'arrow-down'}`"
                  /> -->
                </div>
                <div @click="showZhuanjia">
                  <div
                    :class="`w-item ${showZjAll ? '' : 'van-ellipsis'}`"
                    v-for="(items, d) in author.listSecondPosition"
                    :key="d"
                  >
                    {{ items }}
                  </div>
                </div>
                <!-- <div
                  :class="`to ${
                    author.listSecondPosition &&
                    author.listSecondPosition.length
                      ? 'mt8'
                      : ''
                  }`"
                  @click="toJiangshi(author.userId)"
                >
                  前往讲师主页<van-icon
                    color="rgba(15, 60, 198, 1)"
                    size="12px"
                    name="arrow"
                  />
                </div> -->
                <div
                  class="to-home-page"
                  :class="{
                    mt8:
                      author.listSecondPosition &&
                      author.listSecondPosition.length,
                  }"
                  @click="toJiangshi(author.userId)"
                >
                  <div class="to-text">前往讲师主页</div>
                  <img
                    src="@/assets/H5/play/arrow_right_blue.png"
                    alt=""
                    class="arrow_right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- tab标签 -->
      <div class="tabs-box" v-if="lists.length">
        <van-tabs
          v-model:active="current"
          title-inactive-color="#999999"
          title-active-color="#222222"
          color="#0F3CC6"
          :ellipsis="false"
          @change="changeTab"
          v-if="lists.length > 1"
        >
          <!-- :title="item.name" -->
          <van-tab
            :title="item.name"
            v-for="(item, index) in lists"
            :key="index"
          >
          </van-tab>
        </van-tabs>
        <div class="tab-1" v-if="lists.length == 1">{{ lists[0].name }}</div>
      </div>
    </div>
    <div class="tab-wrap">
      <!-- 直播 -->
      <div class="tab-box zhibo-item-box" v-if="thisContentType === 1">
        <template v-if="lives.length">
          <!-- 仅礼来直播使用，其余可以注释这段代码 -->
          <div
            class="live-box"
            v-if="$route.query.id == 8293 || $route.query.id == 9096"
          >
            本内容仅供中国境内（不含港澳台地区）执业的医疗卫生专业人士参考，不构成对任何药物或治疗方案的推荐、广告或宣传。未经授权不得转载或用于其他用途。
          </div>
          <Live-Items
            v-for="(item, index) of lives"
            :key="item.id"
            :item="item"
            :index="index"
            :activeIndex="liveActiveIndex"
            :isSpecial="false"
            @clickItem="handleClickLiveItem"
            :showVideoTime="true"
          >
          </Live-Items>
        </template>
        <div v-else>
          <van-empty description="" />
        </div>
      </div>
      <!-- 视频 -->
      <div class="tab-box course-item-box" v-if="thisContentType === 2">
        <div v-if="courses.length">
          <Course-Items
            v-for="(item, index) of courses"
            :key="item.id"
            :item="item"
            :index="index"
            :activeIndex="videoActiveIndex"
            :isSpecial="false"
            @currentClick="updateCurrentClick"
            :showVideoTime="true"
            :activeSectionId="activeSectionId"
            @goSectionTimeNode="goSectionTimeNode"
          >
          </Course-Items>
          <!-- 积分兑换 -->
          <div class="exchange-box" v-if="showExchangeBox">
            <div class="left">
              <img src="@/assets/H5/play/jifen.png" alt="" />
              <span class="credits-num">{{ courseCredits }}积分</span>
            </div>
            <div
              class="right"
              @click="handleExchange"
              data-monitor="h5-play-立即兑换"
            >
              <span>立即兑换</span>
            </div>
          </div>
        </div>
        <div v-else>
          <van-empty description="" />
        </div>
      </div>
      <!-- 习题 -->
      <div class="tab-box xiti-item-box" v-if="thisContentType === 10">
        <div>
          <Exercise-Items :id="tabLists[current].id" :current="current">
          </Exercise-Items>
        </div>
        <!-- <div v-else>
          <van-empty description="暂无习题" />
        </div> -->
      </div>
      <!-- 图文 -->
      <div class="tab-box tuwen-item-box" v-if="thisContentType === 3">
        <div
          class="w-e-text"
          v-if="text"
          v-html="text"
          @click="handleClickImg"
        ></div>
        <div v-else>
          <van-empty description="" />
        </div>
      </div>
      <!-- 活动 -->
      <div class="tab-box activity-item-box" v-if="thisContentType === 4">
        <div
          class="active-content w-e-text"
          v-if="activity && activity.content"
          v-html="activity.content"
          @click="handleClickImg"
        ></div>
        <div v-else>
          <van-empty description="" />
        </div>
        <!-- 活动按钮 -->
        <div
          class="active-btn-box"
          id="active-btn-box"
          v-show="activity.message"
        >
          <van-button
            v-show="!whiteFlag"
            size="large"
            block
            type="primary"
            :disabled="!activity.applyStatus"
            round
            @click="signUp"
          >
            {{ activity.message }}
          </van-button>
        </div>
      </div>
      <!-- 文件 -->
      <div class="tab-box wenjian-item-box" v-if="thisContentType === 5">
        <div v-if="files.length">
          <File-Items
            v-for="(file, index) of files"
            :key="index"
            :item="file"
            @clickItem="handleClickFile"
          ></File-Items>
        </div>
        <div v-else>
          <van-empty description="" />
        </div>
      </div>
      <!-- 简介 -->
      <div
        class="tab-box jianjie-item-box carousel-h5"
        v-if="thisContentType === 6"
      >
        <div
          class="jianjie w-e-text"
          v-if="jianjie"
          v-html="jianjie"
          @click="handleClickImg"
        ></div>
        <div v-else>
          <van-empty description="" />
        </div>
      </div>
      <!-- 直播聊天室 -->
      <div class="tab-box livechatroom-item-box" v-if="thisContentType === 20">
        <van-notice-bar
          class="top-info"
          left-icon="https://ntppc.oss-cn-shanghai.aliyuncs.com/mp4/20250220rujriypa.png"
          :text="topChat"
          v-if="topChat"
          @click="totopChatUrl"
          background="rgba(37,78,244,0.1)"
          color="#222222"
        />
        <div class="lcr-list">
          <div
            :class="`lcr-item ${item.isMe ? 'me' : ''} `"
            v-for="item in chatList"
            :key="item.id"
          >
            <template v-if="item.isMe">
              <div class="lcr-item-left">
                <div class="l-i-l-content">{{ item.userChat }}</div>
              </div>
              <div class="lcr-item-right">
                <div class="l-i-r-photo">
                  <img :src="item.userImage" alt="" />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="lcr-item-left">
                <div class="l-i-l-photo">
                  <img :src="item.userImage" alt="" />
                </div>
              </div>
              <div class="lcr-item-right">
                <div class="l-i-r-name">{{ item.userName || "游客" }}</div>
                <div class="l-i-r-content">
                  {{ item.userChat }}
                </div>
              </div>
            </template>
          </div>
          <div class="lcr-new" v-if="addLength" @click="toLast">
            <van-icon name="bulb-o" size="16" /> 新消息+{{ addLength }}
          </div>
        </div>
        <div class="keyboard-box">
          <van-field
            class="input-box"
            placeholder="请输入聊天信息"
            right-icon="guide-o"
            :maxlength="500"
            @focus="handleFocus"
            @blur="handleBlur"
            ref="livechatRef"
            v-model="replyLivechat"
            @click="handleLivechat"
            @click-right-icon="onSubmitChat"
          />
        </div>
      </div>
      <!-- 留言 -->
      <div class="tab-box liuyan-item-box" v-if="thisContentType === 9">
        <div class="liuyan">
          <div class="box">
            <textarea
              v-model="replyComment"
              class="textarea"
              :maxlength="100"
              placeholder="请输入"
            ></textarea>
            <div class="tip">{{ replyComment.length }}/100</div>
          </div>
          <div class="comment-btns flex flex-j-b flex-a-c">
            <van-checkbox
              v-model="isAnonymous"
              shape="square"
              checked-color="#0f3cc6"
              >匿名回复</van-checkbox
            >
            <div class="reply-btn">
              <van-button
                type="primary"
                size="small"
                @click="publishComment"
                block
                color="#0f3cc6"
                >发表</van-button
              >
            </div>
          </div>
        </div>
        <div>
          <Comment-Items
            v-for="(comment, index) of comments"
            :key="comment.id"
            :originItem="comment"
            :index="index"
            @publishComment="handlePublishComment"
            :applyStatus="applyStatus"
          ></Comment-Items>

          <div v-if="comments.length <= 0" class="">
            <van-empty description="暂无内容" />
          </div>
          <div v-else>
            <van-divider @click="getMore">{{ status }}</van-divider>
          </div>
        </div>
      </div>
      <!-- 小程序 -->
      <div class="tab-box miniprogram-item-box" v-if="thisContentType === 8">
        <template v-for="(item, index) in miniprogramRenderArr" :key="index">
          <!-- 富文本 -->
          <div
            class="w-e-text"
            v-if="item.type === 'content'"
            v-html="item.value"
          ></div>
          <!-- 跳转小程序 -->
          <div v-if="item.type === 'miniProgram'">
            <wx-open-launch-weapp
              id="launch-btn"
              :appid="item.id"
              :path="item.linkUrl"
            >
              <div v-is="'script'" type="text/wxtag-template">
                <div style="padding: 6px 10px">
                  <img
                    v-if="item.linkType == 1"
                    style="width: 100%; display: block"
                    :src="item.linkRemark"
                    alt=""
                  />
                  <div v-if="item.linkType == 2" style="line-height: 20px">
                    <img
                      src="@/assets/H5/play/xiaochengxu.png"
                      style="width: 20px; vertical-align: middle"
                    />
                    <span
                      style="
                        color: #0f3cc6;
                        margin-left: 10px;
                        vertical-align: middle;
                      "
                    >
                      {{ item.linkRemark }}</span
                    >
                  </div>
                </div>
              </div>
            </wx-open-launch-weapp>
          </div>
        </template>
      </div>
      <!-- 更多直播会议 -->
      <div
        class="more-meeting-box"
        v-if="
          moreMeetingList.length &&
          showMeetContentId == tabId &&
          (thisContentType == 1 || thisContentType == 2)
        "
      >
        <div class="m-m-title flex flex-a-c">
          <div class="t-l">相关内容</div>
          <div class="m-m-to flex flex-a-c" @click="toMeetingList">
            <div class="text">更多会议回看</div>
            <div class="icon"></div>
          </div>
        </div>
        <div class="m-m-list">
          <div
            class="m-m-item flex"
            v-for="(item, index) in moreMeetingList"
            :key="index"
            @click="goToMeetingDetail(item.id)"
          >
            <div class="item-img">
              <img
                :src="item.bannerH5 ? item.bannerH5 : item.banner"
                :alt="item.name"
              />
            </div>
            <div class="item-info flex">
              <div class="info-title van-multi-ellipsis--l2">
                {{ item.name }}
              </div>
              <div class="info-time">{{ item.createTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 积分兑换操作 -->
    <van-action-sheet
      v-model:show="exchangeModalVisible"
      title="确认订单"
      @cancel="duihuanSheetColse"
    >
      <div class="exchange-content">
        <div class="exchange-info">
          <div class="info-item">
            <span class="tip">兑换内容</span>
            <span class="exchang-goods">{{ item.name }}</span>
          </div>
          <div class="info-item">
            <span class="tip">消耗积分</span>
            <span class="credits-num">{{ courseCredits }}</span>
          </div>
          <div class="info-item">
            <span class="tip">我的积分</span>
            <span
              class="tip"
              @click="
                $router.push({
                  name: 'MyScore',
                })
              "
              >{{ userTotalValidPoints }} <van-icon name="arrow"
            /></span>
          </div>
        </div>
        <div class="exhange-desc">
          <div class="desc-title">说明:</div>
          <div class="decs-detail">
            <div class="detail-item">
              1. 请确认订单信息，虚拟物品兑换后不支持退订；
            </div>
            <div class="detail-item">
              2.
              兑换过程中如出现问题请联系管理员微信或致电13120680582（周一至周五10:00-17:00）进行咨询；
            </div>
            <div class="detail-item">
              3. 兑换成功后可前往个人中心“我的积分”里查看积分明细。
            </div>
          </div>
        </div>

        <div class="btn-box">
          <div
            class="exchange-btn"
            @click="confirmExchange"
            data-monitor="h5-play-确认兑换"
          >
            确认兑换
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!-- 提示：查看需要认证的内容 -> 先认证 -->
    <!-- 无特定职业 -->
    <van-dialog
      :z-index="1000000"
      v-if="thisContentType != 2"
      v-model:show="showInfo1"
      title="提示"
      show-cancel-button
      :message="`此内容仅对认证用户开放\n如需继续浏览，请先完成认证`"
      confirm-button-color="#6f9fff"
      @confirm="sureInfo"
      @cancel="showInfo1 = false"
      confirmButtonText="前往认证"
    >
    </van-dialog>
    <!-- 特定职业：未认证 -->
    <van-dialog
      :z-index="1000000"
      v-if="thisContentType != 2"
      v-model:show="showInfo2"
      title="提示"
      show-cancel-button
      :message="`此内容仅对` + namStr + `开放\n如需继续浏览，请先完成职业认证`"
      confirm-button-color="#6f9fff"
      @confirm="sureInfo"
      @cancel="showInfo2 = false"
      confirmButtonText="前往认证"
    >
    </van-dialog>
    <!-- 特定职业：已认证 -->
    <van-dialog
      :z-index="1000000"
      v-if="thisContentType != 2"
      v-model:show="showInfo3"
      title="提示"
      show-cancel-button
      :message="
        `此内容仅对` +
        namStr +
        `开放\n您当前认证职业为` +
        myTrainerName +
        `，无权限浏览；如您职业已发生变动，请重新认证。`
      "
      confirm-button-color="#6f9fff"
      @confirm="sureInfo"
      @cancel="showInfo3 = false"
      confirmButtonText="前往认证"
    >
    </van-dialog>
    <!-- 提示：报名需要认证的活动 -> 先认证 -->
    <van-dialog
      :z-index="1000000"
      v-model:show="showActivityInfo"
      title="提示"
      show-cancel-button
      message="请先前往个人中心认证通过再来报名"
      confirm-button-color="#6f9fff"
      @confirm="sureActivityInfo"
      @cancel="showActivityInfo = false"
    >
    </van-dialog>

    <!-- 提示：认证审核中 -->
    <van-dialog
      :z-index="1000000"
      v-if="thisContentType != 2"
      v-model:show="showApplyInfo2"
      title="提示"
      message="认证审核中,此内容仅对认证用户开放，审核通过后可查看"
      confirm-button-color="#6f9fff"
      @confirm="showApplyInfo2 = false"
      :show-cancel-button="false"
      confirm-button-text="知道了"
    >
    </van-dialog>

    <!-- 提示：表单信息提交成功 -->
    <van-dialog
      :z-index="1000000"
      v-model:show="showSuccess"
      title="提交成功"
      message="您已提交成功"
      confirm-button-color="#6f9fff"
      @confirm="showSuccess = false"
    ></van-dialog>

    <!-- 报名提交成功 -->
    <van-dialog
      :z-index="1000000"
      v-model:show="activityDialogVisible"
      title="提交成功"
      confirm-button-color="#6f9fff"
      @confirm="activityDialogSubmit"
      show-cancel-button
      cancelButtonText="知道了"
      :showConfirmButton="Boolean(activityDialogInfo.toH5Url)"
      :confirmButtonText="activityDialogInfo.buttonName"
      class="activity-info-dialog"
    >
      <div class="box">
        <div class="paperwork">
          {{ activityDialogInfo.paperwork }}
        </div>
        <van-image
          class="img"
          v-if="activityDialogInfo.imgUrl"
          :src="activityDialogInfo.imgUrl"
        />
      </div>
    </van-dialog>

    <!-- 表单 - 活动报名 -->
    <van-dialog
      v-model:show="showSignUp"
      title="报名信息"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :z-index="1000000"
    >
      <van-form class="pop-form" @submit="sureSignUp">
        <van-cell-group inset>
          <van-field
            label="姓名"
            v-model="activityForm.name"
            placeholder="请输入姓名"
            required
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <van-field
            label="手机号"
            v-model="activityForm.phone"
            placeholder="请输入手机号"
            required
            :maxlength="11"
            :rules="[
              { required: true, message: '请输入手机号' },
              { validator: validPhone },
            ]"
            type="tel"
          />
          <van-field
            label="部门"
            v-model="activityForm.department"
            placeholder="请输入部门"
            required
            :rules="[{ required: true, message: '请输入部门' }]"
          />
          <van-field
            label="单位"
            v-model="activityForm.workplace"
            placeholder="请输入单位"
            required
            :rules="[{ required: true, message: '请输入单位' }]"
          />
          <van-field
            v-model="activityForm.idNumber"
            label="身份证"
            placeholder="请输入身份证号码"
            :rules="[
              {
                validator: checkIdNumber,
                message: '请输入正确的身份证',
              },
            ]"
          />
        </van-cell-group>
        <van-row class="form-btn-box u-m-t-20">
          <van-col span="12">
            <van-button plain block type="default" @click="quxiaobm">
              取消
            </van-button></van-col
          >
          <van-col span="12"
            ><van-button plain block type="primary" native-type="submit">
              提交
            </van-button></van-col
          >
        </van-row>
      </van-form>
    </van-dialog>
    <!-- 表单 - 动态信息改为面板弹出 -->

    <!-- title的这种显示逻辑是礼来特殊 -->
    <van-action-sheet
      class="active-form-sheet"
      v-model:show="showZhiboForm"
      :closeable="false"
      :close-on-click-overlay="false"
      :title="
        $route.query.id == 8293 || $route.query.id == 9096
          ? '会前问答'
          : '填写信息'
      "
      :z-index="1000000"
    >
      <Dynamic-Form
        :formPropsData="originForm"
        @updatedata="submitFormFun2"
      ></Dynamic-Form>
    </van-action-sheet>

    <!-- 弹窗 - 二维码 -->
    <van-dialog
      class="qrCode-pop"
      @close="closePop"
      :closeable="isForceSubscribe ? false : true"
      v-model:show="showQRCode"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :z-index="1000000"
    >
      <div class="img-box">
        <van-image width="161px" height="161px" :src="qrCodeUrl"></van-image>
      </div>
      <div class="text-box">
        <div>关注"{{ wechatAccountSourceName }}"公众号</div>
        <div class="text2">第一时间了解最新课程！</div>
      </div>
    </van-dialog>

    <!-- mini二维码提示 -->
    <div class="qrCode-pop-mini" v-show="showQRCodeMini" @click="showPopAgain">
      <van-image
        :src="require('@/assets/H5/play/erweima@2x.png')"
        width="17px"
        height="16px"
      ></van-image>
    </div>

    <!-- 专栏无内容 -->
    <van-empty v-if="tabLists.length == 0" description="暂无内容"></van-empty>
    <!-- 积分相关 -->
    <!-- 0328大会先去掉新手任务 -->
    <div
      class="score-bottom-tip flex flex-j-b flex-a-c"
      v-show="!showScoreNew && shownewXs && false"
    >
      <div class="box flex flex-a-c">
        <div class="icon"></div>
        <div class="tip">
          完成<span>新手任务</span>，领取<span>专属礼包</span>
        </div>
        <div class="btn">
          <van-button
            round
            color="linear-gradient(134deg, #96B2FF 0%, #7393F5 100%)"
            block
            size="mini"
            @click="toScoreCenter"
            >查看</van-button
          >
        </div>
      </div>

      <div class="close" @click="showScoreNew = true">
        <van-icon name="cross" size="12px" color="#fff" />
      </div>
    </div>
    <!-- 联系辅导员 -->
    <div class="kf-pop" :style="`right: ${setRight}px`" v-if="isKc">
      <div class="img-box" @click="showKFCode = true">
        <van-image :src="require('@/assets/H5/play/icon-kf.png')"></van-image>
      </div>
    </div>
    <van-dialog
      class="kf-dialog"
      :closeable="false"
      v-model:show="showKFCode"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :z-index="1000000"
    >
      <div class="close" @click="closekfPop">
        <van-icon :name="require('@/assets/H5/score/close.png')" />
      </div>
      <div class="img-box">
        <van-image
          :src="require('@/assets/H5/play/kf-' + source + '-erweima.jpg')"
        ></van-image>
      </div>
      <div class="text-box">
        <div>咨询课程、积分奖励或其他帮助</div>
        <div class="text2">请扫码添加辅导员</div>
      </div>
    </van-dialog>
    <!-- 会员补充信息表单 -->
    <van-dialog
      class="form-pop"
      v-model:show="showForm"
      title="完善个人信息"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :z-index="2000"
    >
      <van-form @submit="onSubmitForm">
        <van-cell-group>
          <van-field
            required
            v-model="name"
            label="姓名"
            placeholder="请填写真实姓名"
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <van-field
            required
            type="tel"
            v-model="phone"
            label="手机号"
            placeholder="请填写手机号"
            disabled
            :maxlength="11"
            :rules="[{ required: true, message: '请输入手机号' }]"
          />
          <van-field
            required
            v-model="trainerModel"
            name="picker"
            label="职业"
            placeholder="请选择您的职业"
            readonly
            @click="showzhiye = true"
            :rules="[{ required: true, message: '请选择您的职业' }]"
          />
          <van-field
            required
            v-model="workplace"
            :label="
              trainer === 1 || trainer === 2
                ? '医院'
                : trainer === 5
                ? '学校'
                : '单位'
            "
            :placeholder="`请输入${
              trainer === 1 || trainer === 2
                ? '医院'
                : trainer === 5
                ? '学校'
                : '单位'
            }`"
            :maxlength="50"
            :rules="[
              {
                required: true,
                message: `请输入${
                  trainer === 1 || trainer === 2
                    ? '医院'
                    : trainer === 5
                    ? '学校'
                    : '单位'
                }`,
              },
            ]"
          />
        </van-cell-group>
        <!-- 医生、护士 -->
        <template v-if="trainer === 1 || trainer === 2">
          <van-field
            required
            v-model="keshimodel"
            name="picker"
            label="科室/部门"
            placeholder="请选择您的科室/部门"
            readonly
            @click="showkeshi = true"
            :rules="[{ required: true, message: '请选择您的科室/部门' }]"
          />
        </template>
        <!-- 医疗行业从业者、其他、医生护士选择其他时候用 -->
        <template
          v-if="
            ((trainer === 1 || trainer === 2) &&
              departmentCode &&
              departmentCode == '13/149') ||
            trainer === 3 ||
            trainer === 4 ||
            trainer === 5 ||
            (departmentCode &&
              departmentCode[0] == 13 &&
              departmentCode[1] == 149)
          "
        >
          <van-field
            required
            v-model="departmentName"
            :label="
              trainer === 1 || trainer === 2
                ? '科室'
                : trainer === 5
                ? '专业'
                : '部门'
            "
            :placeholder="`请输入${
              trainer === 1 || trainer === 2
                ? '科室'
                : trainer === 5
                ? '专业'
                : '部门'
            }`"
            :maxlength="50"
            :rules="[
              {
                required: true,
                message: `请输入${
                  trainer === 1 || trainer === 2
                    ? '科室'
                    : trainer === 5
                    ? '专业'
                    : '部门'
                }`,
              },
            ]"
          />
        </template>

        <div class="btn">
          <van-button
            color="rgb(15, 60, 198)"
            size="small"
            block
            round
            native-type="submit"
            >确 定</van-button
          >
        </div>
      </van-form>
    </van-dialog>

    <!-- 表单 - 认证信息 -->
    <van-action-sheet
      v-model:show="showrzForm"
      title="认证信息"
      :close-on-click-overlay="false"
    >
      <div class="rz-content">
        <div class="rejectReason" v-if="rejectReason">
          审核未通过：{{ rejectReason }}
        </div>
        <van-form class="pop-form" @submit="surerzForm">
          <van-cell-group inset>
            <van-field
              label="姓名"
              v-model="name"
              placeholder="请输入姓名"
              required
              :rules="[{ required: true, message: '请输入姓名' }]"
            />
            <van-field
              v-model="idNumber"
              label="身份证"
              required
              :disabled="applyStatus === 0 || applyStatus === 1"
              placeholder="请输入身份证号码"
              :rules="[
                { required: true, message: '请输入身份证' },
                {
                  validator: checkIdNumber,
                  message: '请输入正确的身份证',
                },
              ]"
            />
            <van-field
              v-model="trainerModel"
              name="picker"
              label="职业"
              placeholder="请选择您的职业"
              required
              readonly
              :rules="[{ required: true, message: '请选择您的职业' }]"
              @click="showzhiye = true"
            />
            <van-field
              v-show="trainerModel"
              v-model="workplace"
              :label="workplaceLabel"
              placeholder="请输入"
              required
              :maxlength="50"
              :rules="[{ required: true, message: '请输入' }]"
            />
            <!-- 医生、护士 -->
            <template v-if="trainer === 1 || trainer === 2">
              <van-field
                v-model="keshimodel"
                name="picker"
                label="科室/部门"
                placeholder="请选择您的科室"
                required
                readonly
                :rules="[{ required: true, message: '请选择您的科室' }]"
                @click="showkeshi = true"
              />
            </template>
            <!-- 医疗行业从业者、其他、医生护士选择其他时候用 -->
            <template
              v-if="
                trainer === 3 ||
                trainer === 4 ||
                departmentCode == '13/149' ||
                trainer === 5
              "
            >
              <van-field
                v-model="departmentName"
                :label="departmentLabel"
                placeholder="请输入"
                required
                :maxlength="50"
                :rules="[
                  {
                    required: true,
                    message: trainer === 5 ? '请输入专业' : '请输入科室/部门',
                  },
                ]"
              />
            </template>
            <!-- 认证资料 -->
            <!-- <div class="ziliao" v-if="trainer !== 4">
              <div class="title">工作证</div>
              <div class="label">
                用户信息受法律保护，仅用于认证，其他人不可见
              </div>
            </div> -->
            <div class="upload">
              <div class="label">
                <span>*</span> {{ trainer === 5 ? "学生证" : "工作证" }}
              </div>
              <div class="img">
                <van-uploader
                  v-model="idCard"
                  :after-read="afterRead5"
                  :max-count="1"
                  @delete="delete5"
                />
              </div>
            </div>
          </van-cell-group>
          <van-row class="form-btn-box u-m-t-20">
            <van-col span="24"
              ><van-button
                block
                color="#0f3cc6"
                round
                type="primary"
                native-type="submit"
              >
                提交
              </van-button></van-col
            >
          </van-row>
        </van-form>
      </div>
    </van-action-sheet>

    <van-popup v-model:show="showzhiye" position="bottom">
      <van-picker
        :columns="trainerArr"
        :columns-field-names="{ text: 'label' }"
        @confirm="onConfirmZhiye"
        @cancel="showzhiye = false"
      />
    </van-popup>
    <van-popup v-model:show="showkeshi" position="bottom">
      <van-picker
        title="标题"
        :columns="depementList"
        :columns-field-names="{ text: 'name' }"
        @confirm="onConfirmdept"
        @cancel="showkeshi = false"
      />
    </van-popup>
    <van-dialog
      width="60%"
      class="zbqd-dialog"
      :closeable="false"
      v-model:show="showZhiboSign"
      :show-cancel-button="false"
      confirmButtonText="签到"
      theme="round-button"
      confirmButtonColor="#1989fa"
      @confirm="toSignZhibo"
      :z-index="1000000"
    >
      <div class="text-box">
        <div>专家发起了签到</div>
      </div>
    </van-dialog>

    <!-- 订阅二维码 -->
    <van-dialog
      class="dy-dialog"
      :closeable="false"
      v-model:show="showDyCode"
      :show-cancel-button="false"
      :show-confirm-button="false"
      width="303"
      :z-index="1000000"
    >
      <div class="close" @click="showDyCode = false">
        <van-icon size="22" :name="require('@/assets/H5/score/close.png')" />
      </div>
      <div class="img-box">
        <van-image width="200px" height="200px" :src="yuyueQrCode"></van-image>
      </div>
      <div class="text-box">
        <div>预约成功，关注公众号及时获取开播提醒</div>
      </div>
    </van-dialog>

    <!-- 弹窗 - 广告 -->
    <van-dialog
      class="gg-pop"
      @close="showGgpop = false"
      :closeable="true"
      v-model:show="showGgpop"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :z-index="1000000"
    >
      <div class="img-box">
        <van-image object-fit="contain" :src="ggPopUrl"></van-image>
      </div>
    </van-dialog>

    <!-- 全局广告 -->
    <template v-for="(item, index) in qjggDatas">
      <view
        class="gg-pop-center"
        v-if="item.show && item.position == 'center' && item.pictureH5"
        :key="index"
      >
        <div class="mode"></div>
        <div :class="`pop-box`">
          <div class="pop-img">
            <div class="pop-close" v-if="item.typeFlag != '1'">
              <img
                @click="item.show = false"
                src="@/assets/H5/play/close-center.png"
                alt=""
              />
            </div>
            <div @click="toLinkOther(item)" v-if="item.skipType == '1' && isWx">
              <wx-open-launch-weapp
                id="launch-btn"
                :appid="item.appId"
                :path="item.urlH5 ? item.urlH5 : ''"
              >
                <div v-is="'script'" type="text/wxtag-template">
                  <img
                    style="width: 100%; display: block"
                    :src="item.pictureH5"
                    alt=""
                  />
                </div>
              </wx-open-launch-weapp>
            </div>
            <img
              v-else
              :src="item.pictureH5"
              alt=""
              @click="toLinkOther(item)"
            />
          </div>
        </div>
      </view>
      <view
        class="gg-pop-bottom"
        v-if="item.show && item.position == 'bottom' && item.pictureH5"
        :key="index"
      >
        <div :class="`pop-box`">
          <div class="pop-close" v-if="item.typeFlag != '1'">
            <img
              @click="item.show = false"
              src="@/assets/H5/play/close-bottom.png"
              alt=""
            />
          </div>
          <div class="pop-img">
            <wx-open-launch-weapp
              v-if="item.skipType == '1' && isWx"
              id="launch-btn"
              :appid="item.appId"
              :path="item.urlH5 ? item.urlH5 : ''"
            >
              <div v-is="'script'" type="text/wxtag-template">
                <img
                  @click="toLinkOther(item)"
                  style="width: 100%; display: block"
                  :src="item.pictureH5"
                  alt=""
                />
              </div>
            </wx-open-launch-weapp>
            <img
              v-else
              :src="item.pictureH5"
              alt=""
              @click="toLinkOther(item)"
            />
          </div>
        </div>
      </view>
    </template>
  </div>
  <!-- 课程分享海报 -->
  <div :class="`share-box ${showPoster ? 'show' : 'hide'}`">
    <div class="mark"></div>
    <div class="c-box">
      <div class="name">
        {{ item.name }}
        <div class="close" @click="showPoster = false"></div>
      </div>
      <div class="w-box" ref="imgbox" v-show="showOne">
        <div class="imgs">
          <img :src="item.bannerH5 ? item.bannerH5 : item.banner" alt="" />
        </div>
        <div class="infos">
          <div class="ererma">
            <img :src="hbCodeUrl" alt="" />
          </div>
          <div class="texts">
            <div class="tip1">和我一起来学习</div>
            <div class="tip2">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="fxtp">
        <img
          class="posterImg"
          :src="imgUrl"
          alt="img"
          v-show="imgUrl"
          :style="imgStyleObj"
        />
      </div>
      <div class="b-tip">长按保存图片，邀请好友一起来学习</div>
    </div>
  </div>

  <!-- 弹窗 - 登录 -->
  <van-dialog
    class="login-pop"
    v-model:show="showLoginpop"
    :show-cancel-button="false"
    :show-confirm-button="false"
    z-index="999999"
  >
    <div class="close-box" @click="showLoginpop = false"></div>
    <van-form class="login-form" @submit="onSubmitLogin" label-width="70">
      <van-cell-group :border="false">
        <van-field
          v-model="tel"
          type="tel"
          label="手机号："
          name="tel"
          placeholder="请输入手机号"
          :border="false"
          :maxlength="11"
          :rules="[
            { required: true, message: '请输入手机号' },
            { validator: checkPhone, message: '请输入正确的手机号' },
          ]"
        />
        <van-field
          v-model="code"
          type="number"
          name="code"
          clearable
          center
          label="验证码："
          placeholder="请输入验证码"
          :maxlength="6"
          :rules="[
            { required: true, message: '请输入验证码' },
            {
              validator: check6Code,
              message: '请输入6位数字验证码',
            },
          ]"
        >
          <template #button>
            <span
              @click="handleSendCode"
              :style="{ color: seconds < 120 ? '' : '#0f3cc6' }"
              >{{ btnText }}</span
            >
          </template>
        </van-field>
      </van-cell-group>
      <div class="btn-box">
        <van-button
          class="btn"
          size="small"
          block
          round
          color="#0f3cc6"
          native-type="submit"
        >
          确 定
        </van-button>
      </div>
    </van-form>
  </van-dialog>
  <!-- 随堂练习 -->
  <van-dialog
    v-model:show="showXiTi"
    title=""
    :show-confirm-button="false"
    :class="`xiti-pop ${showBackNavarBar ? '' : 'qp-xiti-pop'}`"
    width="85%"
  >
    <div class="xiti-box" v-if="showXitiList.length">
      <div class="title">随堂练习</div>
      <template v-for="(item, index) in showXitiList" :key="index">
        <div class="xiti-item" v-if="xitiNo == index">
          <div class="max-h">
            <van-field
              :border="false"
              v-if="item.exerciseType == 1"
              name="radio"
              :label="`${item.question}`"
            >
              <template #input>
                <van-radio-group
                  v-model="item.checked"
                  :wrap="true"
                  class="name"
                  :disabled="showAnswer ? true : false"
                >
                  <van-radio
                    v-for="(option, index) in item.optionList"
                    :key="index"
                    :name="option.id"
                    checked-color="rgb(15, 60, 198)"
                    >{{ option.option }}
                    <template #icon="props">
                      <img
                        class="check-icon"
                        :src="
                          props.checked
                            ? require('@/assets/H5/question/checked-icon.png')
                            : require('@/assets/H5/question/unchecked-icon.png')
                        "
                      />
                    </template>
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field
              :border="false"
              v-if="item.exerciseType == 2"
              name="checkbox"
            >
              <template #label>
                <div class="check-title">
                  {{ item.question }}<span class="multi">（多选题）</span>
                </div>
              </template>
              <template #input>
                <van-checkbox-group
                  v-model="item.checked"
                  :wrap="true"
                  :disabled="showAnswer ? true : false"
                >
                  <van-checkbox
                    v-for="(option, index) in item.optionList"
                    :key="index"
                    :name="option.id"
                    checked-color="rgb(15, 60, 198)"
                    @click="checkboxItemChange(item)"
                    >{{ option.option }}
                    <template #icon="props">
                      <img
                        class="check-icon"
                        :src="
                          props.checked
                            ? require('@/assets/H5/question/checked-icon.png')
                            : require('@/assets/H5/question/unchecked-icon.png')
                        "
                      />
                    </template>
                  </van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>

            <div class="daan" v-if="showAnswer">
              <template v-if="item.exerciseType == 1">
                <div class="true-box" v-if="item.answerids == item.checked">
                  <div class="icon dui"></div>
                  <div>回答正确</div>
                </div>
                <div class="false-box" v-else>
                  <div class="false">
                    <div class="icon cuo"></div>
                    <div>很遗憾，答错了</div>
                  </div>
                  <div class="true-daan">
                    <div class="t1">正确答案：</div>
                    <div class="t2">{{ item.answernames }}</div>
                  </div>
                </div>
              </template>
              <template v-if="item.exerciseType == 2">
                <div
                  class="true-box"
                  v-if="item.answerids == item.checked.join(';')"
                >
                  <div class="icon dui"></div>
                  <div>回答正确</div>
                </div>
                <div class="false-box" v-else>
                  <div class="false">
                    <div class="icon cuo"></div>
                    <div>很遗憾，答错了</div>
                  </div>
                  <div class="true-daan">
                    <div class="t1">正确答案：</div>
                    <div class="t2">{{ item.answernames }}</div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div
            :class="`btn ${
              (item.exerciseType == 1 && !item.checked) ||
              (item.exerciseType == 2 && !item.checked.length)
                ? 'no'
                : ''
            }`"
            @click="onConfirmStlx"
          >
            {{ showAnswer ? "继续" : "确定" }}
          </div>
        </div>
      </template>
    </div>
  </van-dialog>
</template>

<script>
import QRCode from "qrcode";
import CourseItems from "@/components/H5/play/CourseItems.vue";
import LiveItems from "@/components/H5/play/LiveItems.vue";
import FileItems from "@/components/H5/play/FileItems.vue";
import CommentItems from "@/components/H5/play/CommentItems.vue";
import DynamicForm from "@/components/H5/dynamicForm.vue";
import ExerciseItems from "@/components/H5/play/ExerciseItems.vue";
import AliPlayer from "@/components/H5/play/AliPlayer.vue";
import { throttle } from "throttle-debounce";
import {
  getJumpUrl,
  getCustomerServiceQrCode,
  setTitle,
  isWechatBrowser,
  get_big_origin,
} from "@/utils/help.js";
import XgPlayer from "@/components/H5/play/XgPlayer.vue";
import cityList from "@/utils/city.json";
import emitter from "@/utils/emitter";

import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  computed,
  onBeforeUnmount,
  watch,
  getCurrentInstance,
  nextTick,
  onUnmounted,
} from "vue";
import { Toast, Dialog, ImagePreview } from "vant";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import {
  getCountdown,
  // getNewTime,
  compareTime,
} from "@/utils/dateFormat";
import {
  setViewTime,
  applyActivity,
  getCommentList,
  getCommentChildList,
  publishComments,
  getOneSpecialDetail,
  getTabDetail,
  dealCollect,
  dealVideoViewNum,
  getUserPublicSubscribe,
  getQRCode,
  getActiveForm,
  addActiveForm,
  userStartSign,
  appointmentDetail,
  appointment,
  getActivityDialogInfo,
  queryAdvertPushAll,
  queryAdvertPushAfter,
  addGgUserInfo,
  queryAdvertOperationPushAll,
  exchangeCourseById,
  addShareCollect,
  addPageBrowserRecord,
  setUserViewsRecords,
  getRecommendListBySize,
  getCommentsTotal,
  submitStlx,
  setUserPageStayTime,
  pediatricsPreConferenceList,
  submitChat,
  getchatList,
  queryCollect,
  addCollect,
  cancelCollect,
  getCourseUserPower,
  getCourseBindProduct,
} from "@/api/play";
import { validateUserPointsTask, eventPoint, userPoints } from "@/api/other";
import useWeChatSdk from "@/hooks/useWeChatSdk";
import {
  getDepementList,
  getStudentNeedMember,
  memberInfo,
  tokenGetCode,
  addApply,
  updateApply,
  bindSendCode,
  bindPhone,
  getUserApply,
} from "@/api/user";
import { checkIdNumber, checkPhone, check6Code } from "@/utils/validate";
import { timeToSecond } from "@/utils/dateFormat";
import PlaySkeleton from "@/components/H5/skeleton/PlaySkeleton";
import html2canvas from "html2canvas";
import oss from "@/utils/aliOss";

export default defineComponent({
  components: {
    CourseItems,
    LiveItems,
    FileItems,
    CommentItems,
    DynamicForm,
    XgPlayer,
    ExerciseItems,
    PlaySkeleton,
    AliPlayer,
  },
  setup() {
    let theme = get_big_origin();
    const showrzForm = ref(false);
    const isWx = isWechatBrowser();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const showQuestion = ref(false);
    let zhuanlanId = ref("");
    let lists = ref([]);
    let user = ref({});
    let applyStatus = ref(3);
    let id = ref("");
    let title = ref("");
    let tabId = ref(0);
    let videoId = ref("");
    let isVideo = ref(false);
    let isLive = ref(false);
    let showInfo1 = ref(false);
    let showInfo2 = ref(false);
    let showInfo3 = ref(false);
    let showActivityInfo = ref(false);
    let showSuccess = ref(false);
    let showSignUp = ref(false);
    let activityForm = reactive({
      activeId: "",
      name: "",
      phone: "",
      department: "",
      workplace: "",
      idNumber: "",
    });
    let item = ref({});
    let courses = ref([]);
    let lives = ref([]);
    let videoActiveIndex = ref(-1);
    let liveActiveIndex = ref(-1);
    let course = ref({});
    let activeLive = ref({});
    let liveId = ref(-1);
    let liveUrls = ref("");
    let text = ref("");
    let activity = ref({});
    let files = ref([]);
    let replyComment = ref("");
    let isAnonymous = ref(false);
    let pageNo = ref(1);
    let pageSize = ref(10);
    let comments = ref([]);
    let status = ref("点击加载更多");
    let total = ref(0);
    let tabLists = ref([]);
    let current = ref(0);
    let thisContentType = ref(0); // 0简介 1直播 2 视频 3图文 4活动报名 5文件 9留言
    let jianjie = ref("");
    let liveErr = reactive({ auth: true, desc: "" });
    let imgTextErr = reactive({ auth: true, desc: "" });
    let descErr = reactive({ auth: true, desc: "" });
    let fileErr = reactive({ auth: true, desc: "" });
    let pageFrom = ref("");
    let haveVideo = ref(false);
    let prevTab = ref(0);
    let currentTime = ref(0);
    let showZhiboForm = ref(false);
    let originForm = ref({});
    let form = ref({});
    let rules2 = ref({});
    let needForm = ref(false);
    let formId = ref("");
    let fromVal = ref("");
    let showApplyInfo = ref(false);
    let showQRCode = ref(false);
    let showQRCodeMini = ref(false);
    let qrCodeUrl = ref(""); //二维码链接
    let isForce = ref(0); //用户是否关注
    let isSubscribe = ref(0); //需要关注
    let isForceSubscribe = ref(0); //强制关注
    let clickVideo = ref(false); //是否是视频
    let clickVideoId = ref(""); //当前显示二维码是在哪个视频
    let subscribeLevel = ref(0); //二维码展示在第几层
    let subscribeTimer = ref(null);
    let scene_id = ref("");
    let userApply = ref(false);
    let showApplyInfo2 = ref(false);
    let thisQuery = router.currentRoute.value.query;
    // thisQuery._path_name = router.currentRoute.value.name;
    let showDidian = ref(false);
    let cascaderValue = ref("");

    //积分相关
    let showScoreTip = ref(false);
    let showScoreNew = ref(false);
    let scoreTip = ref("");
    // 积分兑换相关
    const showExchangeBox = ref(false);
    const courseCredits = ref(0);
    const userTotalValidPoints = ref(0);
    const exchangeModalVisible = ref(false);
    let showForm = ref(false);
    let name = ref("");
    let idNumber = ref("");
    let phone = ref("");
    // 职业
    let trainer = ref("");
    let trainerModel = ref("");
    let workplaceLabel = ref("");
    let departmentLabel = ref("");
    const onConfirmZhiye = (value) => {
      trainer.value = value.value;
      trainerModel.value = value.label;
      showzhiye.value = false;
      if (value.value == 1 || value.value == 2) {
        workplaceLabel.value = "医院";
        departmentLabel.value = "科室";
      } else if (value.value == 3 || value.value == 4) {
        workplaceLabel.value = "单位";
        departmentLabel.value = "部门";
      } else {
        workplaceLabel.value = "学校";
        departmentLabel.value = "专业";
      }
    };
    let workplace = ref("");
    // 科室
    let departmentCode = ref("");
    let keshimodel = ref("");
    const onConfirmdept = (value) => {
      departmentCode.value = value.map((option) => option.id).join("/");
      keshimodel.value = value.map((option) => option.name).join("/");
      showkeshi.value = false;
    };
    let departmentName = ref("");
    let showzhiye = ref(false);
    let trainerArr = ref([]);
    trainerArr.value = [
      {
        label: "医师",
        value: 1,
      },
      {
        label: "护师",
        value: 2,
      },
      {
        label: "技师",
        value: 3,
      },
      {
        label: "药师",
        value: 6,
      },
      {
        label: "在校学生",
        value: 5,
      },
      {
        label: "其他",
        value: 4,
      },
    ];
    let showkeshi = ref(false);
    let depementList = ref([]);
    const showBackNavarBar = ref(true);
    const showNavarBar = (value) => {
      showBackNavarBar.value = value;
      console.log("是否全屏", value);
    };
    // 返回参数
    const backUrl = ref(route.query._back_url);
    // 小程序相关
    const miniprogramRenderArr = ref([]);
    // 提交表单
    let btn_clock = false;
    const onSubmitForm = async () => {
      if (btn_clock) {
        return;
      }
      if (trainer.value != 1 && trainer.value != 2) {
        departmentCode.value = "";
        keshimodel.value = "";
      }
      let datas = {
        name: name.value,
        trainer: trainer.value,
        workplace: workplace.value,
        departmentCode: departmentCode.value,
        department: keshimodel.value,
        departmentName: departmentName.value,
      };
      btn_clock = true;
      await memberInfo(datas);
      Toast.success("提交成功");
      btn_clock = false;
      isFirst.value = false;
      showForm.value = false;
      applyStatus.value = 2;
      showInfo1_video.value = false;
      lastTimePoint.value = null;
      store.dispatch("user/getUserInfoAction");
      // 重新获取活动数据
      await handlerTabDetail(tabId.value, tabLists.value[0]);
    };

    // 科室列表
    const getKeShi = async () => {
      await getDepementList()
        .then((res) => {
          depementList.value = res.results;
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 是否首次
    let isFirst = ref(false);
    let rejectReason = ref("");
    const getFirstInfo = async () => {
      let { results } = await getStudentNeedMember();
      isFirst.value = results.flag;
      let userinfo = store.state.user.userinfo;
      name.value = userinfo.name;
      idNumber.value = userinfo.idNumber;
      phone.value = userinfo.phone;
      trainer.value = userinfo.trainer;
      trainerArr.value.forEach((item) => {
        if (item.value == trainer.value) {
          trainerModel.value = item.label;
        }
      });
      workplace.value = userinfo.workplace;
      keshimodel.value = userinfo.department;
      departmentCode.value = userinfo.departmentCode;
      departmentName.value = userinfo.departmentName;
      if (userinfo.idCard) {
        idCard.value.push({ url: userinfo.idCard });
      }
    };

    // 手机号码校验
    const validPhone = (value) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return "请输入正确的手机号";
      }
    };

    let videoDatas = ref({});
    let lastTime = ref(0);

    // 滚动显示标题栏
    let showTitleNavbar = ref(false);
    const timeupdateVideoDetails = throttle(1000, () => {
      let currentTimes =
        videoDatas.value && videoDatas.value.currentTime
          ? videoDatas.value.currentTime
          : 0;
      // 实时记录播放进度;
      if (currentTimes) {
        currentTime.value = parseInt(currentTimes);
        if (!whiteFlag.value) {
          if (freeTime.value && currentTime.value < freeTime.value) {
            // showShiKanFlag.value = true;
          } else {
            showShiKanFlag.value = false;
            isCanLook.value = false;
            course.value.userViewTime = currentTime.value;
            if (!powerHandle_video(course.value)) {
              return false;
            } else {
              isCanLook.value = true;
              if (
                !showQRCode.value &&
                !showQRCodeMini.value &&
                thisContentType.value == 2
              ) {
                // 关注二维码判断
                if (!forceHandle(course.value)) {
                  return false;
                }
              }
            }
          }
        }
        // 更改激活的章节
        if (course.value.chapterList && !lockClickSection.value) {
          activeSectionId.value = setActiveSectionId();
          course.value.clickSectionId = activeSectionId.value;
        }
        //实时记录用户当前观看视频的时间
        courses.value[currentVideoIndex.value].userViewTime = currentTime.value;
        //给点击章节加锁，防止定时延迟导致激活章节跳转
        lockClickSection.value = false;
        videoGgList.value.forEach((g) => {
          if (
            currentTime.value >= g.startTime &&
            currentTime.value <= g.endTime &&
            currentTime.value != course.value.viewTimeTotal
          ) {
            g.showGgitem = true;
          } else {
            g.showGgitem = false;
          }
        });
      }
      const { viewTimeTotal, viewStatus } = course.value;
      if (!viewStatus) {
        const viewRate = currentTime.value / viewTimeTotal;
        // 大于百分之九十保存进度
        if (viewRate >= 0.9) {
          course.value.viewStatus = 1;
          setViewTimeFun();
        }
      }
      // 每五秒保存一次进度，所以误差小于或等于5秒
      if (lastTime.value != currentTime.value && currentTime.value % 5 === 0) {
        setViewTimeFun(5);
      }
      // 随堂练习
      if (course.value.xitiList && course.value.xitiList.length) {
        for (let i = 0; i < course.value.xitiList.length; i++) {
          let item = course.value.xitiList[i];
          if (
            (item.timePoint == currentTime.value &&
              lastTimePoint.value !== item.timePoint &&
              powerHandle_video(course.value)) ||
            (item.timePoint == currentTime.value &&
              lastTimePoint.value !== item.timePoint &&
              showShiKanFlag.value)
          ) {
            isCanLook.value = false;
            showXiTi.value = true;
            xitiNo.value = 0;
            showAnswer.value = false;
            showXitiList.value = item.list;
            setTimeout(() => {
              isCanLook.value = false;
            }, 1000);
            break;
          }
        }
      }
      lastTimePoint.value = currentTime.value;
    });

    const checkboxItemChange = (item) => {
      item.checked.sort((a, b) => a - b);
    };

    let showXiTi = ref(false);
    let xitiNo = ref(0);
    let showAnswer = ref(false);
    let showXitiList = ref([]);
    let lastTimePoint = ref(null);
    const onConfirmStlx = async () => {
      let item = showXitiList.value[xitiNo.value];
      if (!showAnswer.value) {
        if (
          (item.exerciseType == 1 && item.checked) ||
          (item.exerciseType == 2 && item.checked.length)
        ) {
          showAnswer.value = true;

          let isRight = 0;
          let optionId = "";
          let option = "";
          if (item.exerciseType == 1) {
            isRight = item.answerids == item.checked ? 1 : 0;
            optionId = item.checked + "";
            item.optionList.forEach((i) => {
              if (i.id == item.checked) {
                option = i.option;
              }
            });
          } else {
            isRight = item.answerids == item.checked.join(";") ? 1 : 0;
            optionId = item.checked.join(";");
            item.optionList.forEach((i) => {
              if (item.checked.indexOf(i.id) >= 0) {
                option = option ? option + ";" + i.option : i.option;
              }
            });
          }
          // 提交习题
          let datas = {
            contentId: item.contentId,
            courseId: item.courseId,
            exerciseId: item.exerciseId,
            isRight: isRight,
            option: option,
            optionId: optionId,
            question: item.question,
          };
          await nextTick();
          const box = document.querySelector(".max-h");
          box.scrollTo(0, box.scrollHeight - box.clientHeight); //最底部
          submitStlx(datas);
        }
      } else {
        if (showXitiList.value[xitiNo.value + 1]) {
          xitiNo.value = xitiNo.value + 1;
          showAnswer.value = false;
        } else {
          showXiTi.value = false;
          if (!showRecommend.value) {
            isCanLook.value = true;
          }

          if (lastTimePoint.value !== item.timePoint) {
            lastTimePoint.value = item.timePoint;
          }

          course.value.xitiList.forEach((item) => {
            setTimeout(() => {
              item.list.forEach((i) => {
                if (i.exerciseType == 1) {
                  i.checked = "";
                } else if (i.exerciseType == 2) {
                  i.checked = [];
                }
                showAnswer.value = false;
              });
            }, 1000);
          });
        }
      }
    };

    // 实时记录播放进度
    const timeupdateVideo = (datas) => {
      if (!isCanLook.value) {
        return false;
      }
      videoDatas.value = datas;
      timeupdateVideoDetails();
    };

    // 视频播放 -> 更新进度
    const play = async (datas) => {
      videoDatas.value = datas;
      let currentTimes =
        videoDatas.value && videoDatas.value.currentTime
          ? videoDatas.value.currentTime
          : 0;
      // 实时记录播放进度;
      if (currentTimes) {
        currentTime.value = parseInt(currentTimes);
      }
      await setViewTimeFun();
    };

    // 视频暂停 -> 更新进度
    const pause = async (datas) => {
      videoDatas.value = datas;
      let currentTimes =
        videoDatas.value && videoDatas.value.currentTime
          ? videoDatas.value.currentTime
          : 0;
      // 实时记录播放进度;
      if (currentTimes) {
        currentTime.value = parseInt(currentTimes);
      }
      // await setViewTimeFun(currentTime.value % 5 == 0 ? 5 : 0);
      await setViewTimeFun();
    };

    // 视频结束 -> 更新进度
    const ended = (datas) => {
      videoDatas.value = datas;
      let currentTimes =
        videoDatas.value && videoDatas.value.currentTime
          ? videoDatas.value.currentTime
          : 0;
      // 实时记录播放进度;
      if (currentTimes) {
        currentTime.value = parseInt(currentTimes);
      }
      // setViewTimeFun(currentTime.value % 5);
      setViewTimeFun();
      if (
        course.value.id === courses.value[courses.value.length - 1].id &&
        recommendList.value.length
      ) {
        // 查看购买课程时不需要显示推荐
        if (!jspt_jxjy.value) {
          showRecommend.value = true;
        }
        // 2024-1-12 取消自动播放
        // setPlayNextTimer(); //开启播放下一个倒计时
      }
    };

    //   更新视频进度
    const setViewTimeFun = async (time) => {
      if (time) {
        lastTime.value = currentTime.value;
      }
      if (!videoId.value) {
        return false;
      }
      let params = {
        contentId: videoId.value,
        viewTime: currentTime.value,
        source: theme,
        actualViewTime: time ? time : 0,
      };
      const { results } = await setViewTime(params);
      courses.value.map((item) => {
        if (item.id == videoId.value) {
          item.userViewTime = currentTime.value;
        }
      });
      if (!results) {
        // if (userApply.value && !isCanLook.value) {
        //   //会员：认证信息正在审核中
        //   // showInfo4_video.value = true;
        // } else if (namStr.value && !isCanLook.value) {
        //   // 特殊职业认证后可看
        //   showInfo2_video.value = true;
        // } else if (!isCanLook.value && !namStr.value) {
        //   // 认证后可看
        //   showInfo1_video.value = true;
        // }
      }
    };

    const scrollNavbar = (visiValue) => {
      showTitleNavbar.value = visiValue === "showTitle";
    };
    // 需要认证才能下一步操作 -> 先去认证信息页面
    const sureInfo = () => {
      let themeitem = theme;
      if (themeitem == "THEME_BILIARY_ATRESIA") {
        router.push({ name: "NotForce" });
      } else {
        // router.push({ name: "RenZheng" });
        sureInfotoRz();
      }
      showInfo1.value = false;
      showInfo2.value = false;
      showInfo3.value = false;
    };
    const toBindPhone = () => {
      //去绑定手机号成为会员
      showLoginpop.value = true;
    };
    const sureInfo_video = (id) => {
      if (id && id == 1 && isFirst.value) {
        // 补充会员表单信息
        showForm.value = true;
        return false;
      }
      let themeitem = theme;
      if (themeitem == "THEME_BILIARY_ATRESIA") {
        router.push({ name: "NotForce" });
      } else {
        // router.push({ name: "RenZheng" });
        sureInfotoRz();
      }
      showInfo1_video.value = false;
      // showInfo2_video.value = false;
      // showInfo3_video.value = false;
      lastTimePoint.value = null;
    };

    // 报名前 -> 先去认证信息页面
    const sureActivityInfo = () => {
      showActivityInfo.value = false;
      let themeitem = theme;
      if (themeitem == "THEME_BILIARY_ATRESIA") {
        router.push({ name: "NotForce" });
      } else {
        // router.push({ name: "RenZheng" });
        sureInfotoRz();
      }
    };

    const toQuestion = () => {
      router.push({
        name: "LiveQuestion",
        query: {
          templateId: formQuestionId.value,
          columnId: zhuanlanId.value,
        },
      });
    };

    // 切换tab标签
    const changeTab = async (index) => {
      // 初始化
      setInitDatas();
      showQRCode.value = false;
      showQRCodeMini.value = false;

      current.value = index;
      const { id, contentType } = tabLists.value[index];
      // 直播和视频切换banner 其他不切换
      if (contentType == 1) {
        // 直播
        if (prevTab.value != 1) {
          //原先是视频 或者 其他
          clickVideoId.value = 0;
          course.value = {};
          prevTab.value = contentType;
        }
      } else if (contentType == 2) {
        //视频
        if (prevTab.value != 2) {
          //原先是直播 或者 其他
          liveId.value = 0;
          activeLive.value = {};
          prevTab.value = contentType;
        }
      } else {
        if (prevTab.value != 1 && prevTab.value != 2) {
          //原先是直播 或者 其他
          prevTab.value = contentType;
        }
      }

      thisContentType.value = contentType;
      tabId.value = id;
      // 留言
      if (id == -9) {
        pageNo.value = 1;
        comments.value = [];
        getCommentListsFun();
        if (isAndroid()) {
          window.addEventListener("resize", onResize, true);
        } else if (isIOS()) {
          window.addEventListener("focusin", onFocusin, true);
          window.addEventListener("focusout", onFocussout, true);
        }
      } else {
        window.removeEventListener("focusin", onFocusin); //移除事件
        window.removeEventListener("focusout", onFocussout); //移除事件
        window.removeEventListener("resize", onResize); //移除事件
        await handlerTabDetail(id, tabLists.value[index]);
      }

      //聊天室
      if (contentType == 20) {
        await getchatListInfo();
        await nextTick();
        var lcrlistele = document.getElementsByClassName("lcr-list")[0];
        lcrlistele.scrollTo(
          0,
          Math.ceil(lcrlistele.scrollHeight) -
            Math.ceil(lcrlistele.clientHeight)
        );

        await nextTick();
        lcrlistele.addEventListener(
          "scroll",
          debounce(function () {
            const div = document.getElementsByClassName("lcr-list")[0];
            if (div) {
              scrollToBottom.value =
                Math.ceil(div.scrollHeight) -
                Math.ceil(div.clientHeight) -
                Math.ceil(div.scrollTop);
              if (scrollToBottom.value <= 50) {
                oldLength.value = chatList.value.length;
                addLength.value = 0;
              }
            }
          }, 250)
        );

        oldLength.value = chatList.value.length;
        addLength.value = 0;

        onpenTime();

        if (isAndroid()) {
          window.addEventListener("resize", handleResize, true);
        }
      }
    };

    const onpenTime = () => {
      if (livechatTimer) {
        clearInterval(livechatTimer);
        livechatTimer = null;
      }
      livechatTimer = setInterval(async () => {
        const div = document.getElementsByClassName("lcr-list")[0];
        await getchatListInfo();
        await nextTick();
        if (scrollToBottom.value <= 50) {
          if (oldLength.value < chatList.value.length) {
            div.scrollTo(
              0,
              Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
            );
          }
          oldLength.value = chatList.value.length;
          addLength.value = 0;
        } else {
          addLength.value = chatList.value.length - oldLength.value;
        }
      }, 1000);
    };

    const debounce = (func, wait) => {
      let timeout;
      return function () {
        const context = this,
          args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    };
    let scrollToBottom = ref(0);
    let oldLength = ref(0);
    let addLength = ref(0);

    const toLast = async () => {
      const div = document.getElementsByClassName("lcr-list")[0];
      div.scrollTo(
        0,
        Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
      );
      await nextTick();
      oldLength.value = chatList.value.length;
      addLength.value = 0;
    };
    let livechatTimer = null;

    //去报名
    const signUp = () => {
      activityForm.activeId = activity.value.id;
      // 用户信息
      let userinfo = store.state.user.userinfo;
      const { name, phone, workplace, department, departmentName, idNumber } =
        userinfo;

      // 初始化
      setInitDatas();

      //非白名单
      if (!whiteFlag.value) {
        // 视频权限判断
        if (!powerHandle(activity.value)) {
          return false;
        }
      }

      // extendType 1填资料 0不填资料
      if (activity.value.extendType == 1) {
        activityForm.name = name ?? "";
        activityForm.phone = phone ?? "";
        activityForm.department = department
          ? department
          : departmentName
          ? departmentName
          : "";
        activityForm.workplace = workplace ?? "";
        activityForm.idNumber = idNumber ?? "";
        showSignUp.value = true;
        if (isAndroid()) {
          window.addEventListener("resize", onResize, true);
        } else if (isIOS()) {
          window.addEventListener("focusin", onFocusin, true);
          window.addEventListener("focusout", onFocussout, true);
        }
      } else if (activity.value.extendType == 0) {
        submitFormFun();
      }
    };

    // 确认提交活动报名
    const sureSignUp = async () => {
      await submitFormFun();
      // 获取表单弹框信息
    };

    //取消报名
    const quxiaobm = () => {
      showSignUp.value = false;
      window.removeEventListener("focusin", onFocusin); //移除事件
      window.removeEventListener("focusout", onFocussout); //移除事件
      window.removeEventListener("resize", onResize); //移除事件
      let ele = document.getElementById("active-btn-box");
      if (ele) {
        ele.style.display = "block";
      }
    };

    //   提交活动报名数据
    const submitFormFun = async () => {
      const params = {
        activeId: activityForm.activeId,
        activeApplyDetail: activityForm,
      };
      try {
        await applyActivity(params);
        showSignUp.value = false;
        window.removeEventListener("focusin", onFocusin); //移除事件
        window.removeEventListener("focusout", onFocussout); //移除事件
        window.removeEventListener("resize", onResize); //移除事件
        // 重新获取数据
        getSpecialDetailFun();
        // 获取报名活动弹框信息
        await _getActivityDialogInfo({ columnId: activity.value.perColumnId });
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "提交失败");
      }
    };

    const _getActivityDialogInfo = async (params) => {
      const { results } = await getActivityDialogInfo(params);
      if (results) {
        if (results.buttonName && results.toH5Url) {
          activityDialogInfo.buttonName = results.buttonName;
        }

        activityDialogInfo.paperwork = results.paperwork
          ? results.paperwork
          : "您已提交成功";
        activityDialogInfo.toH5Url = results.toH5Url ? results.toH5Url : "";
        activityDialogInfo.imgUrl = results.imgUrl ? results.imgUrl : "";
      }
      activityDialogVisible.value = true;
    };

    // 一级留言
    const publishComment = async () => {
      if (!phone.value) {
        //去绑定手机号成为会员
        showLoginpop.value = true;

        return false;
      }
      if (replyComment.value.length <= 0) {
        Toast.fail("请输入内容");
        return;
      }
      user.value = store.state.user.userinfo;
      const params = {
        columnId: zhuanlanId.value,
        content: replyComment.value,
        fromUserHeadImg: user.value.imageUrl,
        fromUserId: user.value.userId,
        fromUserName: "",
        roleType: 2,
        type: 1,
      };
      if (isAnonymous.value) {
        params.fromUserName = "匿名用户";
      } else {
        if (user.value.name) {
          params.fromUserName = user.value.name;
        } else {
          params.fromUserName = user.value.phone; // 没姓名用手机号
        }
      }
      await publishCommentFun(params);
      pageNo.value = 1;
      await getCommentListsFun();
    };

    // 二三级留言
    const handlePublishComment = async (value) => {
      if (!phone.value) {
        //去绑定手机号成为会员
        showLoginpop.value = true;

        return false;
      }
      const { item, isFirstComment, index } = value;
      user.value = store.state.user.userinfo;
      const params = {
        columnId: zhuanlanId.value,
        content: item.replyComment,
        fromUserHeadImg: user.value.imageUrl,
        fromUserId: user.value.userId,
        fromUserName: "",
        roleType: 2,
        type: isFirstComment ? 2 : 3,
        commentId: isFirstComment ? item.id : item.commentId,
        replyId: item.id,
        toUserHeadImg: item.fromUserHeadImg,
        toUserId: item.fromUserId,
        toUserName: item.roleType == 3 ? "管理员" : item.fromUserName,
      };
      if (item.isAnonymous) {
        params.fromUserName = "匿名用户";
      } else {
        if (user.value.name) {
          params.fromUserName = user.value.name;
        } else {
          params.fromUserName = user.value.phone; // 没姓名用手机号
        }
      }
      await publishCommentFun(params);
      // 重置
      comments.value[index].pageNo = 1;
      comments.value[index].isShowReply = false;
      comments.value[index].replyComment = "";
      comments.value[index].pageComment.records = [];
      await getChildComments(item, index, isFirstComment);
    };

    // 获取二级留言列表
    const getChildComments = async (item, index, isFirstComment) => {
      try {
        const params = {
          pageNo: 1,
          pageSize: item.pageSize,
          commentId: isFirstComment ? item.id : item.commentId,
        };
        const { results } = await getCommentChildList(params);
        const records = formatDataFun(results.records);
        comments.value[index].pageComment.records = records;
        comments.value[index].pageComment.total = results.total;
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "获取二级评论列表失败");
      }
    };

    // 获取一级留言列表
    const getCommentListsFun = async (isLoadMore = false) => {
      try {
        status.value = "努力加载中";
        const params = {
          columnId: zhuanlanId.value,
          pageNo: pageNo.value,
          pageSize: pageSize.value,
        };
        const { results } = await getCommentList(params);
        const records = formatDataFun(results.pageComment.records);
        if (isLoadMore) {
          comments.value = comments.value.concat(records);
        } else {
          comments.value = records;
        }
        total.value = results.pageComment.total;
        if (total.value > pageNo.value * pageSize.value) {
          status.value = "点击加载更多";
        } else {
          status.value = "没有更多了";
        }
      } catch (e) {
        status.value = "点击加载更多";
        console.error(e);
        Toast.fail(e.message ? e.message : "获取一级评论列表失败");
      }
    };

    //获取更多留言
    const getMore = () => {
      if (status.value == "点击加载更多") {
        pageNo.value = pageNo.value + 1;
        getCommentListsFun(true);
      }
    };

    //   留言处理
    const formatDataFun = (records) => {
      records.forEach((item) => {
        item.isAnonymous = false;
        item.isShowReply = false;
        item.replyComment = "";
        item.pageNo = 1;
        item.pageSize = 3;
        if (item.pageComment && item.pageComment.records.length >= 0) {
          item.pageComment.records = formatDataFun(item.pageComment.records);
        }
      });

      return records;
    };

    //  留言
    const publishCommentFun = async (params) => {
      try {
        await publishComments(params);
        updateCommentTitle();
        replyComment.value = "";
        Toast.success("评论成功");
        eventPoint({ type: 5002 }).then((res) => {
          if (res.results && res.results.flag) {
            Toast.success(
              res.results.description + "+" + res.results.point + "积分"
            );
          }
        });
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "评论失败");
      }
    };

    let whiteFlag = ref("false");
    let isKc = ref(false);

    let isBindTitle = ref(false);

    let zbyyTime = ref("");
    // 是否可预约 appointmentStatus，1是可预约 2是不可预约
    const canAppoint = ref(false);
    const showTime = ref(null);
    const showTimeFlag = ref(false);

    const showShiKanFlag = ref(false);
    const freeTime = ref(0); //试看时常
    const collectFeeStatus = ref(0); //是否需要兑换
    const payStatus = ref(0); //是否已支付

    const secondSpecialName = ref("");

    // 视频进度条是否可以拖动（true：禁止拖动，false：允许拖动）
    // 来源1：路由参数 disableProgress 有值时禁止拖动（如专项培训流程内的普通课程）
    const routeDisableProgress = computed(() => {
      const val = route.query.disableProgress;
      return val !== undefined && val !== null && val !== "";
    });
    // 来源2：后端配置 dragFlag：0-不可以拖动，1-可以拖动
    const dragFlagDisableProgress = ref(false);
    // 最终值：两个业务任一命中即禁止拖动
    const disableProgress = computed(
      () => routeDisableProgress.value || dragFlagDisableProgress.value
    );

    const openShare = ref(false);
    const myIsShare = ref(false);
    let syncFlag = ref(0);
    let patientEducationId = ref(0);
    let showMeetContentId = ref(null);
    let whitePower = ref(false);
    const formQuestionId = ref("");
    //   进入专栏
    const getSpecialDetailFun = async () => {
      // 初始化数据
      setInitDatas();

      try {
        // 获取专栏内容
        const params = {
          id: zhuanlanId.value,
        };
        const { results } = await getOneSpecialDetail(params);
        console.log(results, "results");
        // 后端配置：dragFlag 0-不可以拖动，1-可以拖动
        dragFlagDisableProgress.value = results.dragFlag === 0 ? true : false;
        whitePower.value = results.whitePower;
        syncFlag.value = results.syncFlag ? results.syncFlag : 0;
        patientEducationId.value = results.patientEducationId
          ? results.patientEducationId
          : 0;

        isLivechatOpen.value = results.chatButton ? true : false;
        topChat.value = results.topChat;
        topChatUrl.value = results.topChatUrl;

        if (syncFlag.value) {
          generateQrCode();
        }

        if (results.isPreviousConferenceTag) {
          // 是往期会议  获取推荐内容
          pediatricsPreConferenceList({ id: zhuanlanId.value }).then((res) => {
            if (res.results) {
              res.results.map((item) => {
                item.createTime = item.releaseTime
                  ? item.releaseTime.split(" ")[0]
                  : item.createTime.split(" ")[0];
              });
              let arrs = res.results.filter(
                (item) => item.id != zhuanlanId.value
              );
              moreMeetingList.value = arrs.splice(0, 4);
            }
          });
        }

        // 试看时长
        freeTime.value = results.freeTime ? results.freeTime : 0;
        collectFeeStatus.value = results.collectFeeStatus
          ? results.collectFeeStatus
          : 0;
        // 是否展示兑换 collectFeeStatus： 0免费，1收费
        showExchangeBox.value =
          results.collectFeeStatus && !results.payStatus ? true : false;
        // 兑换所需积分
        courseCredits.value = results.credits;
        // payStatus：0未兑换，1兑换
        payStatus.value = results.payStatus ? results.payStatus : 0;

        // 讲师数据
        if (results.author) {
          results.author.listSecondPosition = results.author.listSecondPosition
            ? results.author.listSecondPosition
            : [];
          if (results.author.majorPosition) {
            results.author.listSecondPosition.unshift(
              results.author.majorPosition
            );
          }
          if (results.author.workplace) {
            results.author.listSecondPosition.unshift(results.author.workplace);
          }
          author.value = results.author;
        }

        // 是否是课程
        isKc.value = results.isCourseTag;

        // 专栏信息
        item.value = results;
        // 是否可预约 1可预约，2不可预约
        canAppoint.value = results.appointmentStatus === 1;
        // 直播预约时间
        zbyyTime.value = item.value.liveTime
          ? item.value.liveTime.replace(new RegExp("-", "gm"), "/")
          : "";

        // let query_obj = GetRequest();
        // delete query_obj._userid_;
        // let str = buildQueryString(query_obj);
        // let link_url =
        //   location.href.split("?")[0] +
        //   "?" +
        //   str +
        //   "&_userid_=" +
        //   store.state.user.userinfo.userId;

        const url = new URL(location.href);
        url.searchParams.delete("_userid_");
        // 设置当前用户 ID
        url.searchParams.set("_userid_", store.state.user.userinfo.userId);
        const link_url = url.toString();

        // 微信分享
        useWeChatSdk(
          item.value.name ? item.value.name : "",
          item.value.title ? item.value.title : "",
          link_url,
          item.value.bannerH5 ? item.value.bannerH5 : item.value.banner,
          theme
        );

        // 修改title
        if (item.value.name) {
          setTitle(item.value.name);
          secondSpecialName.value = item.value.name;
        }

        // 填写动态表单
        if (results.needForm) {
          needForm.value = results.needForm;
        }
        // 动态表单ID
        if (results.formId) {
          formId.value = results.formId;
        }

        // 是否需要分享
        if (results.shareButton) {
          openShare.value = results.shareButton && isWx ? true : false;
        }
        // 我是否已分享
        if (results.isShare) {
          myIsShare.value = results.isShare ? true : false;
        }

        // 是否有习题
        isBindTitle.value = results.isBindTitle ? results.isBindTitle : false;
        if (results.columnList) {
          let arrs = JSON.parse(JSON.stringify(results.columnList));
          arrs.forEach((item) => {
            // 视频的习题
            if (item.bindExercise) {
              results.columnList.forEach((clo, i) => {
                if (clo.name == item.name && clo.id == item.id) {
                  results.columnList.splice(i + 1, 0, {
                    name: "习题",
                    contentType: 10,
                    id: item.id,
                  });
                }
              });
            }
          });
          //直播聊天室
          results.columnList.forEach((clo, i) => {
            if (clo.contentType == 1 && isLivechatOpen.value) {
              results.columnList.splice(i + 1, 0, {
                name: "聊天室",
                contentType: 20,
                id: 20,
              });
            }
          });
        }

        //tab列表
        tabLists.value = results.columnList;

        secondContentLoading.value = false;

        // 是有开启留言板
        if (results.commentButton == 1) {
          tabLists.value.push({
            name: commentTitle.value,
            contentType: 9,
            id: -9,
          });
        }

        // 是否开启会后问卷
        if (results.formQuestionButtion == 1) {
          showQuestion.value = true;
          formQuestionId.value = results.formQuestionId;
        }
        // tab中是否有视频或者直播
        haveVideo.value = false;
        // 导航列表
        lists.value = [];

        if (tabLists.value.length > 0) {
          tabLists.value.forEach((item) => {
            let obj = {
              name: item.name,
              id: item.id,
              type: item.contentType,
            };
            if (item.contentType === 1 || item.contentType === 2) {
              haveVideo.value = true;
            }
            lists.value.push(obj);
          });
          if (haveVideo.value) {
            for (let i of tabLists.value) {
              if (i.contentType == 1 || i.contentType == 2) {
                thisContentType.value = i.contentType;
                prevTab.value = i.contentType;
                tabId.value = i.id;
                showMeetContentId.value = tabId.value;
                await handlerTabDetail(tabId.value, i);
                break;
              }
            }
            lists.value.forEach((i, d) => {
              if (i.id == tabId.value && i.type == thisContentType.value) {
                current.value = d;
              }
            });

            return false;
          } else {
            thisContentType.value = tabLists.value[0].contentType;
            prevTab.value = tabLists.value[0].contentType;
            tabId.value = tabLists.value[0].id;
          }

          // 留言
          if (tabId.value == -9) {
            pageNo.value = 1;
            comments.value = [];
            getCommentListsFun();
          } else {
            await handlerTabDetail(tabId.value, tabLists.value[0]);
          }
        }
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "获取专栏详情失败");
      }
    };

    const GetRequest = (urlStr) => {
      let url = "";
      if (typeof urlStr == "undefined") {
        url = decodeURI(location.search);
      } else {
        url = "?" + urlStr.split("?")[1];
      }
      var theRequest = {};
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    };

    const buildQueryString = (param) => {
      let paramStr = "";
      for (let key in param) {
        paramStr += "&" + key + "=" + param[key];
      }
      return paramStr.substr(1);
    };

    let myTrainer = ref("");
    let videoBanner = ref("");
    const secondContentLoading = ref(true);
    const yuyueQrCode = ref("");

    //获取tab详情
    const handlerTabDetail = async (id, changeItem) => {
      // 白名单
      whiteFlag.value = changeItem.whiteFlag;

      try {
        const { results } = await getTabDetail({
          id,
        });
        if (results[0] && !results[0].whiteFlag) {
          if (results[0].whiteFlag === false) {
            if (whitePower.value === 1) {
              // 不可观看
              isVideo.value = true;
              videoBanner.value = results[0].banner;
              Dialog.alert({
                title: "温馨提示",
                message: "该内容仅对特定用户开放。",
                showConfirmButton: false,
              });
              return;
            }
          }
        }
        if (results) {
          //视频
          if (thisContentType.value == 2) {
            subscribeLevel.value = 4;

            if (results.length <= 0) {
              Toast.fail("视频未发布");
              return false;
            }

            courses.value = results.map((item) => {
              item.isShowSection = false; //是否展开
              item.clickSectionId = 0; //每个视频点击的章节id
              return item;
            });
            if (courses.value.length) {
              videoBanner.value = courses.value[0].banner;
            }
            if (tabId.value == id) {
              isVideo.value = true;
              let videoFlag = false;
              let obj = {};
              let index = 0;
              let arrs = [".mp4"];
              courses.value.forEach((item, i) => {
                if (clickVideoId.value == item.id) {
                  videoFlag = true;
                  obj = item;
                  index = i;
                }
                item.wbLink = false;
                let itemArr = item.content ? item.content.split(".") : [];
                let strs = "." + itemArr[itemArr.length - 1];
                if (!arrs.includes(strs)) {
                  item.wbLink = true;
                }
              });
              if (videoFlag) {
                obj.isShowSection = true; //第一次打开先展开章节
                handleClickItem({
                  item: obj,
                  index: index,
                }); //播放原来的
                videoActiveIndex.value = index;
              } else {
                if (courses.value.length > 1) {
                  let hasVideo = false;
                  for (let j in courses.value) {
                    let item = courses.value[j];
                    if (!item.wbLink) {
                      hasVideo = true;
                      handleClickItem({
                        item: item,
                        index: j,
                      }); //自动播放第一个视频
                      break;
                    }
                  }
                  if (!hasVideo) {
                    videoActiveIndex.value = -1;
                    course.value = {};
                  }
                } else if (courses.value.length == 1) {
                  if (courses.value[0].wbLink) {
                    videoActiveIndex.value = -1;
                    course.value = {};
                  } else {
                    handleClickItem({
                      item: courses.value[0],
                      index: 0,
                    }); //自动播放第一个
                  }
                }
              }
            } else {
              isVideo.value = false;
            }
          } else if (thisContentType.value == 4) {
            //活动
            subscribeLevel.value = 3;
            results.trainerAuth = changeItem.trainerAuth;
            activity.value = results;

            let ele = document.getElementById("active-btn-box");
            ele.style.display = "block";

            if (activity.value.message == "报名成功") {
              //报名成功
              // 动态表单判断
              if (!tableHandle()) {
                return false;
              }

              // 关注二维码判断
              if (!forceHandle(changeItem)) {
                return false;
              }
            }
          } else {
            subscribeLevel.value = 3;
            if (results && results.length > 0) {
              // 初始化
              setInitDatas();
              // isLive.value = true;
              if (zbyyTime.value && canAppoint.value) {
                showTimeFlag.value = true;
                getCountdown(
                  (v) => {
                    showTime.value = v;
                    if (!v) {
                      showTime.value = "";
                      showTimeFlag.value = false;
                    }
                    // if (showTime.value == "" || showTime.value == null) {
                    //   showTime.value = "";
                    //   showTimeFlag.value = false;
                    // } else {
                    //   showTimeFlag.value = true;
                    // }
                  },
                  new Date(zbyyTime.value).getTime(),
                  1000
                );
              }

              // 直播要分享
              if (
                thisContentType.value == 1 &&
                openShare.value &&
                !myIsShare.value
              ) {
                // return false;
              }

              //非白名单
              if (!whiteFlag.value) {
                // 视频权限判断
                if (!powerHandle(changeItem)) {
                  return false;
                }
              }

              // 动态表单判断
              if (!tableHandle()) {
                return false;
              }

              // 关注二维码判断
              if (!forceHandle(changeItem)) {
                return false;
              }

              //直播
              if (thisContentType.value == 1) {
                lives.value = results;
                if (tabId.value == id) {
                  let zhiboFlag = false;
                  let obj = {};
                  let index = 0;
                  lives.value.forEach((item, i) => {
                    if (liveId.value == item.id) {
                      zhiboFlag = true;
                      obj = item;
                      index = i;
                    }
                  });
                  if (zhiboFlag) {
                    handleClickLiveItem({
                      item: obj,
                      index: index,
                    }); //播放原来的
                  } else {
                    handleClickLiveItem({
                      item: lives.value[0],
                      index: 0,
                    }); //自动播放第一个
                  }

                  // activeLive.value = lives.value[0];
                  // liveId.value = lives.value[0].id;
                  // liveActiveIndex.value = 0;
                } else {
                  isLive.value = false;
                }

                // 获取详情 动态获取预约图片
                const detail = tabLists.value[current.value];
                const asyncYuyueQrCode = require(`@/assets/H5/qrcode/${
                  detail.remark ? detail.remark : "YM_EXPERT"
                }.jpg`);
                yuyueQrCode.value = asyncYuyueQrCode;
              }
              //图文
              if (thisContentType.value == 3) {
                text.value = results[0].content;
              }
              //文件
              if (thisContentType.value == 5) {
                files.value = results;
              }
              //简介
              if (thisContentType.value == 6) {
                jianjie.value = results[0].content;
              }
              // 小程序
              if (thisContentType.value == 8) {
                miniprogramRenderArr.value = JSON.parse(results[0].content);
              }
            }
          }
        }
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "获取tab详情失败");
      }
    };

    const returnShikan = (item) => {
      let flag = true;
      if (freeTime.value) {
        if (course.value.userViewTime < freeTime.value) {
          let arr = [];
          if (item.trainerAuth) {
            arr = item.trainerAuth.split(",");
            namStr_video.value = "";
            trainerArr.value.forEach((item) => {
              if (item.value == myTrainer.value) {
                myTrainerName.value = item.label;
              }
              arr.forEach((a) => {
                if (a == item.value) {
                  namStr_video.value = namStr_video.value
                    ? namStr_video.value + "、" + item.label
                    : item.label;
                }
              });
            });
          }
          showShiKanFlag.value = true;
          flag = false;
        } else {
          showShiKanFlag.value = false;
          flag = true;
        }
      } else {
        showShiKanFlag.value = false;
        flag = true;
      }
      return flag;
    };

    let videoGgList = ref([]);
    // let allpass = ref(false);
    // 点击视频
    const handleClickItem = async (value) => {
      const { item, index } = value;
      activeSectionId.value = 0;
      courses.value.forEach((course) => {
        if (course.id !== item.id) {
          course.isShowSection = false;
        }
      });
      currentSectionList.value = item.chapterList?.map((chapter) => ({
        id: chapter.id,
        timeNode: timeToSecond(chapter.timeNode),
      }));
      item.isShowSection = true;
      // 当前点击的视频
      clickVideoId.value = item.id;

      // 初始化
      setInitDatas_video();

      // 视频播放
      if (course.value.id != item.id) {
        lastTimePoint.value = null;
        isVideo.value = true;
        lastTime.value = item.userViewTime ? item.userViewTime : 0;
        currentTime.value = item.userViewTime ? item.userViewTime : 0;
        course.value = item;
        videoId.value = item.id;
        videoActiveIndex.value = index;
        dealVideoViewNumFun(item.id, index);

        item.exerciseVoList.forEach((ex) => {
          ex.contentId = item.id;
          ex.courseId = item.perColumnId;
          if (ex.exerciseType == 1) {
            ex.checked = "";
            ex.answerids = "";
            ex.answernames = "";
            ex.optionList.forEach((op) => {
              if (op.answer) {
                ex.answerids = op.id;
                ex.answernames = op.option;
              }
            });
          } else if (ex.exerciseType == 2) {
            ex.checked = [];
            ex.answerids = "";
            ex.answernames = "";
            let arrs = [];
            ex.optionList.forEach((op) => {
              if (op.answer) {
                arrs.push(op.id);
                ex.answernames = ex.answernames
                  ? ex.answernames + ";" + op.option
                  : op.option;
              }
            });
            arrs.sort((a, b) => a - b);
            arrs.forEach((a) => {
              ex.answerids = ex.answerids ? ex.answerids + ";" + a : a;
            });
          }
        });
        course.value.xitiList = groupByReduce(item.exerciseVoList, "timePoint");

        // 获取这个视频绑定的广告列表
        let { results } = await queryAdvertPushAll({
          relationId: item.id,
          relationType: 2,
        });

        if (results.length) {
          let ggarr = [];
          //未终止的
          let validArr = results.filter((val) => val.status != 1);
          validArr.forEach((val) => {
            if (val.advertMaterialList) {
              val.advertMaterialList.forEach((a) => {
                a.item_id = val.id;
                a.showGgitem = false;
                a.ts_id = val.id;
                a.startTime = val.videoTime ? timeEvent(val.videoTime) : 0;
                a.showTime =
                  val.showTime && val.showTime > 0
                    ? val.showTime
                    : 999999999999999;
                a.endTime = a.startTime + a.showTime;
                a.height =
                  a.perpendicularDistance > a.horizontalDistance
                    ? (1 - a.perpendicularDistance / 100) * 212
                    : "";
                a.width =
                  a.perpendicularDistance > a.horizontalDistance
                    ? (1 - a.perpendicularDistance / 100) * 375
                    : "";
                ggarr.push(a);
              });
            }
          });
          videoGgList.value = ggarr;
        }
      }

      // 课程要分享
      if (openShare.value && !myIsShare.value) {
        isCanLook.value = false;
        return false;
      }

      // 动态表单判断
      if (!tableHandle()) {
        // 未填表单时不可播放
        isCanLook.value = false;
        return false;
      }

      //非白名单
      if (!whiteFlag.value) {
        // 视频权限判断
        if (!powerHandle_video(item)) {
          if (!showShiKanFlag.value) {
            isCanLook.value = false;
            return false;
          } else {
            isCanLook.value = true;
            return false;
          }
        }
      } else {
        // allpass.value = true;
        showExchangeBox.value = false;
        isCanLook.value = true;
      }

      // 关注二维码判断
      if (!forceHandle(item)) {
        return false;
      } else {
        isCanLook.value = true;
      }

      // 非视频打开新页面
      let arrs = [".mp4"];
      let itemArr = item.content ? item.content.split(".") : [];
      let strs = "." + itemArr[itemArr.length - 1];
      if (!arrs.includes(strs)) {
        location.assign(item.content);
        return false;
      }
    };

    const groupByReduce = (data, name) => {
      var listArr = [];
      data.forEach(function (el) {
        for (var i = 0; i < listArr.length; i++) {
          // 对比相同的字段key，相同放入对应的数组
          if (listArr[i][name] == el[name]) {
            listArr[i].list.push(el);
            return;
          }
        }
        // 第一次对比没有参照，放入参照
        listArr.push({
          timePoint: el[name],
          list: [el],
        });
      });
      listArr.sort((a, b) => a[name] - b[name]);
      return listArr;
    };

    const timeEvent = (e) => {
      var time = e;
      var len = time.split(":");
      if (len.length == 3) {
        let hour = time.split(":")[0];
        let min = time.split(":")[1];
        let sec = time.split(":")[2];
        return Number(hour * 3600) + Number(min * 60) + Number(sec);
      }
      if (len.length == 2) {
        let min = time.split(":")[0];
        let sec = time.split(":")[1];
        return Number(min * 60) + Number(sec);
      }
      if (len.length == 1) {
        let sec = time.split(":")[0];
        return Number(sec);
      }
    };

    const loadeddata = () => {
      // 每次设置时间在该方法设置
      const video = document.getElementById("playVideo");
      video.currentTime = course.value.userViewTime;
    };

    let namStr = ref("");
    let myTrainerName = ref("");

    // 权限/动态表单/二维码统一初始化
    const setInitDatas = () => {
      //职业name
      namStr.value = "";

      // 需要认证初始化
      showApplyInfo2.value = false;
      showInfo1.value = false;
      showInfo2.value = false;
      showInfo3.value = false;

      // 需要动态表单初始化

      // 二维码初始化
      isSubscribe.value = "";
      isForceSubscribe.value = "";
      qrCodeUrl.value = "";
      // 定时器
      if (subscribeTimer.value) {
        clearInterval(subscribeTimer.value);
        subscribeTimer.value = null;
      }

      if (livechatTimer) {
        clearInterval(livechatTimer);
        livechatTimer = null;
      }
    };

    const setInitDatas_video = () => {
      //职业name
      namStr.value = "";

      // 需要认证初始化
      currentTime.value = 0;
      isCanLook.value = true;
      // allpass.value = true;
      showShiKanFlag.value = false;
      showInfo1_video.value = false;
      showInfo2_video.value = false;
      showInfo3_video.value = false;
      showInfo4_video.value = false;
      showInfo5_video.value = false;

      // 需要动态表单初始化

      // 二维码初始化
      isSubscribe.value = "";
      isForceSubscribe.value = "";
      qrCodeUrl.value = "";
      showQRCodeMini.value = false;
      // 定时器
      if (subscribeTimer.value) {
        clearInterval(subscribeTimer.value);
        subscribeTimer.value = null;
      }
    };

    let showInfo1_video = ref(false);
    let showInfo2_video = ref(false);
    let showInfo3_video = ref(false);
    let showInfo4_video = ref(false);
    let showInfo5_video = ref(false);
    let namStr_video = ref("");

    // 权限统一处理
    const powerHandle_video = (item) => {
      // 白名单优先级最高
      if (item.whiteFlag) {
        return true;
      }

      // 特殊职业要求
      let arr = [];
      if (item.trainerAuth) {
        arr = item.trainerAuth.split(",");
        namStr_video.value = "";
        trainerArr.value.forEach((item) => {
          if (item.value == myTrainer.value) {
            myTrainerName.value = item.label;
          }
          arr.forEach((a) => {
            if (a == item.value) {
              namStr_video.value = namStr_video.value
                ? namStr_video.value + "、" + item.label
                : item.label;
            }
          });
        });
      }
      // allpass.value = false;
      if (item.videoButton == 1) {
        // 认证后可看
        if (applyStatus.value == 3) {
          if (!returnShikan(item)) {
            return false;
          }
          if (!phone.value) {
            //游客 -> 去绑定手机号成为会员
            showInfo2_video.value = true;
            return false;
          } else {
            if (!userApply.value) {
              //会员 -> 去认证
              showInfo2_video.value = true;
              return false;
            }
          }
        } else if (applyStatus.value == 2) {
          if (!returnShikan(item)) {
            return false;
          }
          // 会员
          if (!userApply.value) {
            // 去认证
            showInfo2_video.value = true;
            return false;
          }
        }
        //已认证
        if (arr.length && arr.indexOf(myTrainer.value) == -1) {
          if (!returnShikan(item)) {
            return false;
          }
          if (!userApply.value) {
            //职业不符
            showInfo3_video.value = true;
            return false;
          }
        }
        // 收费
        if (collectFeeStatus.value && !payStatus.value) {
          if (!returnShikan(item)) {
            return false;
          }
          showInfo5_video.value = true;
          return false;
        }
        return true;
      } else if (item.videoButton == 2) {
        // 会员可看
        if (applyStatus.value == 3) {
          if (!returnShikan(item)) {
            return false;
          }
          // 补充会员表单信息
          if (isFirst.value) {
            showInfo1_video.value = true;
            return false;
          }
        }
        // 收费
        if (collectFeeStatus.value && !payStatus.value) {
          if (!returnShikan(item)) {
            return false;
          }
          showInfo5_video.value = true;
          return false;
        }
        return true;
      } else {
        // 收费
        if (collectFeeStatus.value && !payStatus.value) {
          if (!returnShikan(item)) {
            return false;
          }
          showInfo5_video.value = true;
          return false;
        }
        return true;
      }
    };
    const powerHandle = (item) => {
      let flag = true;

      // 特殊职业要求
      let arr = [];
      if (item.trainerAuth) {
        arr = item.trainerAuth.split(",");
        trainerArr.value.forEach((item) => {
          if (item.value == myTrainer.value) {
            myTrainerName.value = item.label;
          }
          arr.forEach((a) => {
            if (a == item.value) {
              namStr.value = namStr.value
                ? namStr.value + "、" + item.label
                : item.label;
            }
          });
        });
      }

      if (item.videoButton == 1) {
        // 认证后可看
        if (applyStatus.value == 3) {
          if (!phone.value) {
            //游客 -> 去绑定手机号成为会员
            showLoginpop.value = true;
            flag = false;
            return false;
          } else {
            if (userApply.value) {
              //会员：认证信息正在审核中
              // showApplyInfo2.value = true;
              flag = true;
              return true;
            } else {
              //会员 -> 去认证
              if (arr.length) {
                showInfo2.value = true;
              } else {
                showInfo1.value = true;
              }
            }
            flag = false;
            return false;
          }
        } else if (applyStatus.value == 2) {
          // 会员
          if (userApply.value) {
            //会员：认证信息正在审核中
            // showApplyInfo2.value = true;
            flag = true;
            return true;
          } else {
            // 去认证
            if (arr.length) {
              showInfo2.value = true;
            } else {
              showInfo1.value = true;
            }
          }
          flag = false;
          return false;
        } else {
          //已认证
          if (arr.length && arr.indexOf(myTrainer.value) == -1) {
            if (userApply.value) {
              //修改资料正在审核中 - > 下一步
              flag = true;
              return true;
            } else {
              //职业不符
              showInfo3.value = true;
              flag = false;
              return false;
            }
          }
        }
      } else if (item.videoButton == 2) {
        // 会员可看
        if (applyStatus.value == 3) {
          if (!phone.value) {
            //游客 -> 去绑定手机号成为会员
            showLoginpop.value = true;

            flag = false;
            return false;
          }
          // 补充会员表单信息
          if (isFirst.value) {
            showForm.value = true;
            flag = false;
            return false;
          }
        } else {
          // 补充会员表单信息
          if (isFirst.value) {
            showForm.value = true;
            flag = false;
            return false;
          }
        }
      } else {
        // 游客可以看
      }
      return flag;
    };

    // 动态表单统一判断
    const tableHandle = () => {
      let flag = true;
      if (needForm.value) {
        getZhiboModel();
        flag = false;
      }
      return flag;
    };

    let wechatAccountSource = ref("");
    let wechatAccountSourceName = ref("");
    let wASNObj = {
      YM_EXPERT: "基层医学教学平台",
      YM_NERVE: "脑健康行动",
      YM_PM: "精准医学",
      YM_EYE: "眼科",
    };
    let isLivechatOpen = ref(true);
    let topChat = ref("");
    let topChatUrl = ref("");
    // 关注二维码统一判断
    const forceHandle = async (item) => {
      // 未关注公众号
      isSubscribe.value = item.isSubscribe; //需要关注
      isForceSubscribe.value = item.isForceSubscribe; //需要强制关注
      // qrCodeUrl.value = item.customQrCode; //二维码链接
      wechatAccountSource.value = item.wechatAccountSource
        ? item.wechatAccountSource
        : "YM_EXPERT";
      wechatAccountSourceName.value = wASNObj[wechatAccountSource.value];
      await getUserPublic();
      let flag = true;
      if (!isForce.value) {
        if (isSubscribe.value) {
          // 需要关注

          // 无二维码 -> 获取二维码链接
          getQRCodeUrl();
          // if (!qrCodeUrl.value) {
          // }

          // 开启实时定时器获取用户关注状态
          if (subscribeTimer.value) {
            clearInterval(subscribeTimer.value);
            subscribeTimer.value = null;
            subscribeTimer.value = setInterval(async () => {
              await getUserPublicStatus();
            }, 2000);
          } else {
            subscribeTimer.value = setInterval(async () => {
              await getUserPublicStatus();
            }, 2000);
          }

          //显示二维码
          showQRCode.value = true;
          if (isForceSubscribe.value) {
            showQRCodeMini.value = false;
            flag = false;
          } else {
            showQRCodeMini.value = true;
          }
          showSuccess.value = false;
        }
      }
      return flag;
    };

    let zhiboSocket = null;
    const url = process.env.VUE_APP_LIVE_WEBSOCKET;
    const socketId = ref("");

    const toYyzhibo = async () => {
      if (!phone.value) {
        //去绑定手机号成为会员
        showLoginpop.value = true;

        return false;
      }
      let { code } = await appointment({ secondId: zhuanlanId.value });
      if (code == 1) {
        showDyCode.value = true;
        zbyyStatus.value = true;
      }
    };

    const zbyyStatus = ref(false);
    const showDyCode = ref(false);
    let ggList = ref([]);
    let ggTimer = ref(null);
    // 点击直播
    const handleClickLiveItem = async (value) => {
      const { item, index } = value;
      let newggList = [];

      // 直播未开始
      if (activeLive.value.id != item.id) {
        isLive.value = true;
        activeLive.value = item;
        liveId.value = item.id;
        liveActiveIndex.value = index;

        let user = store.state.user.userinfo;
        if (user) {
          const userId = user.userId;
          socketId.value = item.id;

          if (zhiboSocket) {
            zhiboSocket.close();
          }
          zhiboSocket = new WebSocket(
            `${url}/webSocketSign/${socketId.value}/${userId}`
          );

          // 接收服务端推送过来的消息
          zhiboSocket.onmessage = async function (evt) {
            const received_msg = evt.data;
            console.log("--- 直播签到 ---");
            console.log(received_msg);

            // 如果有json数据
            if (received_msg.startsWith("{") && received_msg.endsWith("}")) {
              try {
                const result = JSON.parse(received_msg);
                if (result.messageType == "SIGN") {
                  signTaskId.value = result.signTaskId;
                  // 直接弹框提示
                  getZhiboMsg(result);
                }
                if (result.messageType == "advert") {
                  let arr_list = [];
                  if (result.operate == "update") {
                    //新增 & 更新
                    let { results } = await queryAdvertPushAfter({
                      relationId: item.id,
                      relationType: 1,
                    });
                    arr_list = results;
                  }
                  if (result.operate == "now") {
                    //立即推送
                    newggList = [];
                    newggList = datasArrange(result.advertPush, item.id);
                    let arr = JSON.parse(JSON.stringify(ggList.value));
                    arr = arr.concat(newggList);
                    funGgTimer(arr);
                  } else if (result.operate == "stop") {
                    //终止
                    newggList = [];
                    newggList = JSON.parse(JSON.stringify(ggList.value));
                    let arr = newggList.filter(
                      (g) => g.ts_id != result.advertPushId
                    );
                    funGgTimer(arr);
                  } else if (result.operate == "update") {
                    newggList = [];
                    //更新
                    for (let all_i of arr_list) {
                      newggList = newggList.concat(
                        datasArrange(all_i, item.id)
                      );
                    }
                    let arr = JSON.parse(JSON.stringify(ggList.value)).filter(
                      (item) => item.showGgitem
                    );
                    arr = arr.concat(newggList);
                    funGgTimer(arr);
                  }
                }
              } catch (e) {
                console.log(e);
              }
            }
          };

          // 发生错误时调用
          zhiboSocket.onerror = function (err) {
            console.error("直播签到：websocket error", err);
            zhiboSocket = null;
            socketId.value = "";
          };
          // 关闭时调用
          zhiboSocket.onclose = function () {
            console.log("直播签到：websocket close");
            zhiboSocket = null;
            socketId.value = "";
          };

          // 获取这个直播绑定的广告列表
          let { results } = await queryAdvertPushAll({
            relationId: item.id,
            relationType: 1,
          });
          if (results.length) {
            let ggarr = [];
            //未终止的
            let validArr = results.filter((val) => val.status != 1);
            validArr.forEach((val) => {
              if (val.advertMaterialList) {
                val.advertMaterialList.forEach((a) => {
                  a.showGgitem = false;
                  a.item_id = item.id;
                  a.ts_id = val.id;
                  a.endTime = val.endTime;
                  a.startTime = val.liveTime;
                  a.showTime =
                    val.showTime && val.showTime > 0
                      ? val.showTime
                      : 999999999999999;
                  a.height =
                    a.perpendicularDistance > a.horizontalDistance
                      ? (1 - a.perpendicularDistance / 100) * 212
                      : "";
                  a.width =
                    a.perpendicularDistance > a.horizontalDistance
                      ? (1 - a.perpendicularDistance / 100) * 375
                      : "";
                  ggarr.push(a);
                });
              }
            });
            funGgTimer(ggarr);
          }
        }
      }
    };
    const datasArrange = (datas, id) => {
      let ggArr = [];
      if (datas.advertMaterialList) {
        datas.advertMaterialList.forEach((a) => {
          a.showGgitem = false;
          a.item_id = id;
          a.ts_id = datas.id;
          a.endTime = datas.endTime;
          a.startTime = datas.liveTime;
          a.showTime = datas.showTime > 0 ? datas.showTime : "";
          a.height =
            a.perpendicularDistance > a.horizontalDistance
              ? (1 - a.perpendicularDistance / 100) * 212
              : "";
          a.width =
            a.perpendicularDistance > a.horizontalDistance
              ? (1 - a.perpendicularDistance / 100) * 375
              : "";
          ggArr.push(a);
        });
        return ggArr;
      } else {
        return [];
      }
    };

    const internalInstance = getCurrentInstance();
    const funGgTimer = (datas) => {
      // 清除定时器
      if (ggTimer.value) {
        clearInterval(ggTimer.value);
        ggTimer.value = null;
      }
      ggTimer.value = setInterval(() => {
        for (let item of datas) {
          if (item.endTime) {
            if (!compareTime(item.startTime) && compareTime(item.endTime)) {
              item.showGgitem = true;
            } else {
              item.showGgitem = false;
            }
          } else {
            if (!compareTime(item.startTime)) {
              item.showGgitem = true;
            } else {
              item.showGgitem = false;
            }
          }
        }
        ggList.value = JSON.parse(JSON.stringify(datas));
        // 操作数据后更新视图
        internalInstance.ctx.$forceUpdate();
      }, 2000);
    };

    const closeVideoGg = (item) => {
      closeGg(item, 2);
    };

    // 关闭广告
    const closeGg = (item, type) => {
      if (type == 1) {
        ggList.value.forEach((g, i) => {
          if (
            g.ts_id == item.ts_id &&
            item.id == g.id &&
            item.advertId == g.advertId
          ) {
            ggList.value.splice(i, 1);
          }
        });
        funGgTimer(ggList.value);
      } else {
        videoGgList.value.forEach((g, i) => {
          if (
            g.ts_id == item.ts_id &&
            item.id == g.id &&
            item.advertId == g.advertId
          ) {
            videoGgList.value.splice(i, 1);
          }
        });
      }
    };

    // 点击文件
    const handleClickFile = (item) => {
      let content = item.content;
      let fileType = content
        .substring(content.lastIndexOf(".") + 1)
        .toLowerCase();
      // 去webview页面 使用pdf自定义处理
      if (fileType === "pdf") {
        router.push({ name: "FileView", query: { url: item.content } });
      } else {
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(content)
        );
      }
    };

    // 收藏
    const videoCollection = () => {
      if (!phone.value) {
        //去绑定手机号成为会员
        showLoginpop.value = true;

        return false;
      }
      const params = {
        contentId: course.value.id,
      };
      if (
        router.currentRoute.value.query.userId &&
        router.currentRoute.value.query.relationType
      ) {
        params.relationId = router.currentRoute.value.query.userId;
        params.relationType = router.currentRoute.value.query.relationType;
      }
      dealCollect(params)
        .then(() => {
          let message = "";
          if (course.value.collection) {
            message = "取消收藏成功";
          } else {
            message = "收藏成功";
          }
          course.value.collection = !course.value.collection;
          Toast.success(message);
        })
        .catch((err) => {
          console.error(err);
          Toast.fail(err.message ? err.message : "操作失败");
        });
    };

    // 获取视频观看次数
    const dealVideoViewNumFun = (id, index) => {
      dealVideoViewNum({
        id,
      }).then(() => {
        courses.value[index]["viewNum"]++;
      });
      myTrainer;
    };

    // 获取用户身份状态
    const getUserStatusFun = async () => {
      const user = await store.dispatch("user/getUserInfoAction");
      const token = localStorage.getItem("token");
      if (user && token) {
        try {
          let results = user.status;
          applyStatus.value = results;
          //   获取用户认证状态
          getUserApply().then((res) => {
            let datas = res.results;
            rejectReason.value = datas.rejectReason;
            userApply.value =
              datas && datas.status && datas.status == 1 ? true : false;
            myTrainer.value = user.trainer ? user.trainer + "" : "";
          });
        } catch (e) {
          console.error(e);
        }
      }
    };

    // 去习题页面
    const toExercise = () => {
      router.push({
        name: "Exercise",
        query: {
          courseId: tabLists.value[current.value].id,
        },
      });
    };

    let btnClock = ref(false); //按钮锁

    // 提交动态表单信息
    const submitFormFun2 = async (val) => {
      const params = {
        status: applyStatus.value,
        templateId: formId.value,
        columnId: zhuanlanId.value,
        content: JSON.stringify(val),
      };
      try {
        // 按钮锁
        if (btnClock.value) {
          return false;
        }
        btnClock.value = true;
        await addActiveForm(params);
        showZhiboForm.value = false;
        needForm.value = false;
        showSuccess.value = true;
        btnClock.value = false; //解锁
        // 重新获取活动数据
        tabLists.value.forEach(async (item) => {
          if (tabId.value == item.id) {
            await handlerTabDetail(tabId.value, item);
          }
        });
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "提交失败");
      }
    };

    // 获取动态表单模板
    const getZhiboModel = async () => {
      try {
        const { results } = await getActiveForm({
          id: formId.value,
        });
        originForm.value = JSON.parse(results.content);
        showZhiboForm.value = true;
      } catch (e) {
        console.error(e);
        Toast.fail(e.message ? e.message : "获取转动态表单模板失败");
      }
    };

    //   展示动态表单
    const toShow = (val) => {
      showZhiboForm.value = val;
    };

    // 去认证页面
    const sureInfo1 = () => {
      let themeitem = theme;
      if (themeitem == "THEME_BILIARY_ATRESIA") {
        router.push({ name: "NotForce" });
      } else {
        // router.push({ name: "RenZheng" });
        sureInfotoRz();
      }
      showApplyInfo = false;
    };

    const sureInfotoRz = () => {
      if (trainer.value == 1 || trainer.value == 2) {
        workplaceLabel.value = "医院";
        departmentLabel.value = "科室";
      } else if (trainer.value == 3 || trainer.value == 4) {
        workplaceLabel.value = "单位";
        departmentLabel.value = "部门";
      } else {
        workplaceLabel.value = "学校";
        departmentLabel.value = "专业";
      }
      showrzForm.value = true;
    };

    // 打开页面判断用户是否已关注公众号
    const getUserPublic = async () => {
      try {
        const { results } = await getUserPublicSubscribe({
          source: wechatAccountSource.value,
          sceneId: "",
        });
        isForce.value = results;
      } catch (e) {
        console.error(e);
      }
    };

    // 用户是否已关注公众号 & 二维码状态
    const getUserPublicStatus = async () => {
      if (isForce.value) {
        //已关注
        showQRCodeMini.value = false;
        showQRCode.value = false;

        // 清除定时器
        clearInterval(subscribeTimer.value);
        subscribeTimer.value = null;

        //重新获取数据
        getSpecialDetailFun();
        return false;
      }
      // 未关注
      try {
        const { results } = await getUserPublicSubscribe({
          source: wechatAccountSource.value,
          sceneId: scene_id.value,
        });
        isForce.value = results;
      } catch (e) {
        console.error(e);
        if (e.message == "二维码已失效，请重新扫描") {
          // 二维码过期
          getQRCodeUrl();
        }
      }
    };

    // 获取零时二维码
    const getQRCodeUrl = async () => {
      try {
        const { results } = await getQRCode({
          source: wechatAccountSource.value,
          themeSource: theme,
        });
        qrCodeUrl.value = await generateQR(results.data.url);
        scene_id.value = results.scene_id;
      } catch (e) {
        console.error(e);
      }
    };

    // 转换二维码图片
    const generateQR = async (text) => {
      try {
        return await QRCode.toDataURL(text);
      } catch (err) {
        console.error(err);
      }
    };

    // 再次展示二维码
    const showPopAgain = async () => {
      showQRCode.value = true;
    };

    // 收起二维码
    const closePop = () => {
      showQRCode.value = false;
    };

    let showKFCode = ref(false);
    const closekfPop = () => {
      showKFCode.value = false;
    };

    let adressPickerType = ref("");
    let adreddFormKey = ref("");
    // 省市区
    const showAddressPop = (datas) => {
      const { type, key } = datas;
      adressPickerType.value = type;
      adreddFormKey.value = key;
      showDidian.value = true;
    };

    // 省市区
    let province = ref("");
    let city = ref("");
    let area = ref("");
    let regionCode = ref("");
    const didianModel = ref("");
    const didianModel2 = ref("");
    const onFinish = ({ selectedOptions }) => {
      province.value = selectedOptions[0].text;
      city.value = selectedOptions[1].text;
      area.value = selectedOptions[2].text;
      regionCode.value = selectedOptions
        .map((option) => option.value)
        .join(",");
      showDidian.value = false;
      didianModel.value = selectedOptions
        .map((option) => option.text)
        .join("/");
      didianModel2.value = selectedOptions
        .map((option) => option.text)
        .join(",");
      form.value["didianModel"] = didianModel.value;
      form.value[adreddFormKey.value] =
        didianModel2.value + "|" + regionCode.value;
    };

    const onClickLeft = async () => {
      if (backUrl.value) {
        location.assign(decodeURIComponent(backUrl.value));
      } else {
        router.back();
      }
    };
    let shownewXs = ref(true);
    let defaultPhoneHeight = ref(0); //屏幕默认高度
    let nowPhoneHeight = ref(0); //屏幕现在的高度
    let ua = ref("");
    const isIOS = () => {
      return /iPhone|iPod|iPad/i.test(ua.value) ? 1 : 0;
    };
    const isAndroid = () => {
      return /Android/i.test(ua.value) ? 1 : 0;
    };

    const isMobileDevice = () => {
      // 常见的移动设备标识
      var isMobile = screen.width < 1200 ? true : false;

      return isMobile;
    };
    console.log("hahha", isMobileDevice(), window);
    const onFocusin = () => {
      let ele = document.getElementById("active-btn-box");
      if (ele) {
        ele.style.display = "none";
      }
      shownewXs.value = false;
    };
    const onFocussout = () => {
      let ele = document.getElementById("active-btn-box");
      if (ele) {
        ele.style.display = "block";
      }
      shownewXs.value = true;
    };
    const onResize = () => {
      nowPhoneHeight.value = window.innerHeight;
      if (defaultPhoneHeight.value > nowPhoneHeight.value) {
        // 键盘弹出事件处理
        let ele = document.getElementById("active-btn-box");
        if (ele) {
          ele.style.display = "none";
        }
        shownewXs.value = false;
      } else {
        // 键盘收起事件处理
        let ele = document.getElementById("active-btn-box");
        if (ele) {
          ele.style.display = "block";
        }
        shownewXs.value = true;
      }
    };

    // 去积分中心
    const toScoreCenter = () => {
      let user = store.state.user.userinfo;
      if (!user.phone) {
        //游客需要先绑定手机

        showLoginpop.value = true;
        return false;
      }
      router.push({ name: "MyScore" });
    };

    const getMsg = (data) => {
      scoreTip.value = data.description + "，获得" + data.point + "积分";
      showScoreTip.value = true;
      setTimeout(() => {
        showScoreTip.value = false;
      }, 20000);
    };

    const showZhiboSign = ref(false);
    const getZhiboMsg = (msg) => {
      if (msg) {
        showZhiboSign.value = true;
        setTimeout(() => {
          showZhiboSign.value = false;
        }, 120000);
      }
    };
    const signTaskId = ref("");
    const toSignZhibo = async () => {
      const { code } = await userStartSign({ signTaskId: signTaskId.value });
      if (code == 1) {
        Toast("签到成功！");
        showZhiboSign.value = false;
      }
    };

    // 是否有观看权限
    const isCanLook = ref(true);

    const getzbdyDetail = async () => {
      const { results } = await appointmentDetail({
        secondId: zhuanlanId.value,
      });
      zbyyStatus.value = results;
    };

    const isPower = ref(true);
    const isCourseUserPower = async () => {
      let { results } = await getCourseUserPower({
        id: zhuanlanId.value,
      });
      isPower.value = results ? true : false;
    };

    // 查询课程是否绑定商品
    const BindProductList = ref([]);
    const CourseBindProduct = async () => {
      let { results } = await getCourseBindProduct({
        id: zhuanlanId.value,
      });
      BindProductList.value = results || [];
    };

    let tlscTimer = null;
    let qjggDatas = ref([]);
    let source = ref("");
    let moreMeetingList = ref([]);
    const jspt_jxjy = ref(false);
    onMounted(async () => {
      source.value = await getCustomerServiceQrCode(theme); // 动态来源 YM_EXPERT、YM_NERVE、YM_PM
      zhuanlanId.value = router.currentRoute.value.query.id;

      jspt_jxjy.value = router.currentRoute.value.query.jspt_jxjy;
      // 查询课程是否绑定商品
      try {
        await CourseBindProduct();
      } catch (e) {
        console.error("查询课程绑定商品失败", e);
      }
      // 仅对「已绑定商品(即付费课)」的课程校验购买；未绑定的免费课直接放行
      if (BindProductList.value.length > 0) {
        try {
          await isCourseUserPower();
        } catch (e) {
          console.error("购买权限校验失败", e);
        }
        if (!isPower.value) {
          if (router.currentRoute.value.query._back_url) {
            window.location.href = router.currentRoute.value.query._back_url;
            return;
          } else {
            Dialog.alert({
              title: "温馨提示",
              message: "您未购买该课程，不能播放，请购买后观看！",
            });
            return;
          }
        }
      }

      if (router.currentRoute.value.query._userid_) {
        addPageBrowserRecord({
          linkKey: "columnShareInner",
          linkUrl: location.href,
        });
      }

      // 用户停留时长
      if (tlscTimer) {
        clearInterval(tlscTimer);
        tlscTimer = null;
      }
      // 当前时间戳
      let timeStr = new Date().getTime();
      let params = {
        userPageId: timeStr,
        columnId: zhuanlanId.value,
      };
      setUserPageStayTime(params).then((res) => {
        console.log("进入页面啦:" + res);
      });
      // 三分钟传递一次
      tlscTimer = setInterval(() => {
        setUserPageStayTime(params).then((res) => {
          console.log("进入页面 +3 秒:" + res);
        });
      }, process.env.VUE_APP_USER_STAY_TIME);

      emitter.on("play_share", getShareMsg);

      // 获取全局广告
      let { results: ggDatas } = await queryAdvertOperationPushAll({
        relationId: zhuanlanId.value,
        relationType: 6,
        flag: sessionStorage.getItem("qjggFlag") ? true : "",
      });
      if (ggDatas && ggDatas.length) {
        ggDatas.map((item) => {
          item.show = true;
          item.position =
            item.operation == "3"
              ? "center"
              : item.operation == "4"
              ? "bottom"
              : "center";
          qjggDatas.value.push(item);
        });
      }
      sessionStorage.setItem("qjggFlag", true);
      await getFirstInfo();
      await getKeShi();
      // await getContentAuthFun();
      handleScroll();
      emitter.on("video_view", getMsg);
      let user = store.state.user.userinfo;
      const { results } = await validateUserPointsTask({
        taskType: 1,
        userId: user.userId,
      });
      showScoreNew.value = results ? results : false;

      // 刘舒扬 特殊逻辑
      let themeitem = theme;
      if (
        user &&
        user.userId == 13403 &&
        themeitem != "THEME_BILIARY_ATRESIA"
      ) {
        return false;
      }
      await getzbdyDetail();
      // 获取用户身份状态
      await getUserStatusFun();
      // 获取用户是否收藏
      await getGueryCollect();
      // 获取专栏信息
      await getSpecialDetailFun();
      Toast.clear();

      defaultPhoneHeight.value = window.innerHeight;
      ua.value = typeof window === "object" ? window.navigator.userAgent : "";
      // 获取 播放结束推荐列表
      getRecommendList();
      if (router.currentRoute.value.query._re_content_) {
        addPageBrowserRecord({
          linkKey: "recommended_content",
          linkUrl: location.href,
        });
      }
    });

    const isCollect = ref(false);
    const getGueryCollect = async () => {
      let { results } = await queryCollect({
        type: 1,
        relationId: zhuanlanId.value,
        relationType: 12,
      });
      isCollect.value = results ? true : false;
    };

    const onSC = async () => {
      if (isCollect.value) {
        await cancelCollect({
          type: 1,
          relationId: zhuanlanId.value,
          relationType: 12,
        });
        isCollect.value = false;
        Toast({
          message: "取消收藏成功",
        });
        return false;
      } else {
        await addCollect({
          type: 1,
          relationId: zhuanlanId.value,
          relationType: 12,
        });
        isCollect.value = true;
        Toast({
          message: "收藏成功",
        });
        return false;
      }
    };

    let oldScrollTop = ref(0); //记录上一次滚动结束后的滚动距离
    let scrollTop = ref(0); // 记录当前的滚动距离

    function handleScroll() {
      window.addEventListener("scroll", () => {
        scrollTop.value = window.scrollY;
      });
    }

    let setRight = ref(16);
    watch(scrollTop, (newValue, oldValue) => {
      setTimeout(() => {
        if (newValue == window.scrollY) {
          setRight.value = 16;
          oldScrollTop.value = newValue;
        }
      }, 200);
      if (oldScrollTop.value == oldValue) {
        setRight.value = -25;
      }
    });

    const getShareMsg = async (datas) => {
      console.log("分享成功", datas);
      let { results } = await addShareCollect({
        relationId: zhuanlanId.value,
        relationType: 7,
        type: 5,
      });
      if (results) {
        Toast({
          position: "top",
          message: "知识，分享和获取一样重要",
        });
        myIsShare.value = true;
      }
      // 重新获取活动数据
      handlerTabDetail(tabId.value, tabLists.value[0]);
    };

    // 去讲师
    const toJiangshi = async (id) => {
      let { results: code } = await tokenGetCode();
      const url = getJumpUrl("EXPERT_APPLET", {
        _code: code,
        id: id,
        _to_path: "detail",
      });
      location.assign(url);
    };

    onBeforeUnmount(() => {
      clearTimeout(nextPlayTimer);
      nextPlayTimer = null;
      clearInterval(tlscTimer);
      tlscTimer = null;

      // 清除做题记录
      let origin = theme;
      let pilotIndex = sessionStorage.getItem("showIndex");
      sessionStorage.clear();
      if (pilotIndex) {
        sessionStorage.setItem("showIndex", pilotIndex);
      }
      if (origin) {
        sessionStorage.setItem("_big_origin", origin);
      }
      if (subscribeTimer.value) {
        clearInterval(subscribeTimer.value);
        subscribeTimer.value = null;
      }
      window.removeEventListener("focusin", onFocusin); //移除事件
      window.removeEventListener("focusout", onFocussout); //移除事件
      window.removeEventListener("resize", onResize); //移除事件

      window.removeEventListener("scroll", () => {});
    });

    let showZjAll = ref(false);
    const showZhuanjia = () => {
      showZjAll.value = !showZjAll.value;
    };

    let author = ref("");

    const activityDialogVisible = ref(false);
    const activityDialogInfo = reactive({
      buttonName: "确认",
      toH5Url: "",
      paperwork: "您已提交成功",
      imgUrl: "",
    });

    const activityDialogSubmit = () => {
      activityDialogVisible.value = false;
      if (activityDialogInfo.toH5Url) {
        window.open(activityDialogInfo.toH5Url);
      }
    };

    const toVideoGg = (item) => {
      toLink(item, 2);
    };

    let showGgpop = ref(false);
    let ggPopUrl = ref("");
    const toLink = async (item, type) => {
      if (item.skipType == 2) {
        // 弹窗
        if (item.urlH5) {
          showGgpop.value = true;
          ggPopUrl.value = item.urlH5;
        }
      } else {
        if (item.urlH5) {
          let { results } = await addGgUserInfo({
            advertId: item.advertId,
            advertMaterialId: item.id,
            advertPushId: item.ts_id,
            relationId: item.item_id,
            relationType: type,
          });
          if (results) {
            location.assign(item.urlH5);
          }
        }
      }
    };

    const handleClickImg = (e) => {
      const event = e || window.event;
      const target = event.target || event.srcElement;
      if (
        target &&
        target.tagName === "IMG" &&
        target.hasAttribute("data-href")
      ) {
        const href = target.getAttribute("data-href");
        href && location.assign(decodeURIComponent(href));
      }
      if (
        target &&
        target.tagName === "IMG" &&
        !target.hasAttribute("data-href")
      ) {
        ImagePreview([target.src]);
      }
    };

    const toLinkOther = (item) => {
      let { results } = addGgUserInfo({
        advertId: item.id,
        advertMaterialId: item.advertMaterialId,
        advertPushId: item.advertPushId,
        relationId: zhuanlanId.value,
        relationType: 6,
      });
      console.log(results);
      if (item.skipType != "1" && item.urlH5) {
        window.open(item.urlH5, "_blank");
      }
    };
    // 积分兑换相关 - 处理方法
    const handleExchange = async () => {
      // 这里得先判断是否有手机号
      if (!phone.value) {
        showLoginpop.value = true;

        return false;
      } else {
        const params = {
          userId: Number(store.state.user.userinfo.userId),
        };
        const { results } = await userPoints(params).catch(() => {});
        userTotalValidPoints.value = results.totolValidPoints;
        if (userTotalValidPoints.value < courseCredits.value) {
          Dialog.confirm({
            title: "积分不足",
            message: `您当前剩余积分为${userTotalValidPoints.value}，不能满足此次兑换所需积分，暂不能兑换。`,
            confirmButtonText: "赚积分",
            confirmButtonColor: "#0F3CC6",
            cancelButtonText: "知道了",
          })
            .then(() => {
              addPageBrowserRecord({
                linkKey: "h5-play-赚积分",
                linkUrl: location.href,
              });
              // 跳去积分中心
              router.push({
                name: "MyScore",
              });
            })
            .catch(() => {
              addPageBrowserRecord({
                linkKey: "h5-play-知道了",
                linkUrl: location.href,
              });
            });
        } else {
          exchangeModalVisible.value = true; //显示确认兑换
        }
      }
    };
    const confirmExchange = async () => {
      const res = await exchangeCourseById({
        columnId: zhuanlanId.value,
        payPoint: courseCredits.value,
      }).catch(() => {});
      if (res && res.code === 1) {
        Toast.success("兑换成功");
        showExchangeBox.value = false;
        isCanLook.value = true;
        // allpass.value = true;
        payStatus.value = true;
        showInfo5_video.value = false;
        lastTimePoint.value = null;
        if (freeTime.value && currentTime.value >= freeTime.value) {
          // 关注二维码判断
          if (!forceHandle(course.value)) {
            return false;
          }
        }
      } else {
        Toast.fail("兑换失败，请刷新后重试");
      }
      exchangeModalVisible.value = false;
    };

    // 视频章节
    const activeSectionId = ref(-1);
    const lockClickSection = ref(false); //点击章节时加锁
    const currentSectionList = ref([]);
    const setActiveSectionId = () => {
      let activeId = 0;
      for (let i = 0; i < currentSectionList.value.length; i++) {
        if (
          currentTime.value >= currentSectionList.value[i].timeNode &&
          (i === currentSectionList.value.length - 1 ||
            currentTime.value < currentSectionList.value[i + 1].timeNode)
        ) {
          activeId = currentSectionList.value[i].id;
          break;
        } else if (
          i == currentSectionList.value.length - 1 &&
          currentTime.value > currentSectionList.value[i].timeNode
        ) {
          activeId = currentSectionList.value[i].id;
        } else {
          activeId = -1;
        }
      }
      // if (activeId === null && currentSectionList.value.length > 0) {
      //   activeId =
      //     currentSectionList.value[currentSectionList.value.length - 1].id;
      // }
      return activeId;
    };
    const goSectionTimeNode = (clickSection) => {
      closeRecommend();
      course.value.userViewTime = timeToSecond(clickSection.timeNode);
      course.value.clickSectionId = clickSection.id;
      activeSectionId.value = clickSection.id;
      // currentTime.value = timeToSecond(clickSection.timeNode);
      lockClickSection.value = true;
    };
    // 当前播放的视频索引，实时修改播放时间
    const currentVideoIndex = ref(0);
    // 当前点击的视频
    const currentClickVideoId = ref(-1);
    const updateCurrentClick = (clickObj) => {
      closeRecommend();
      currentClickVideoId.value = clickObj.item.id;
      currentVideoIndex.value = clickObj.index;
      // 如果点击正在播放的视频,收起
      if (clickVideoId.value == currentClickVideoId.value) {
        clickObj.item.isShowSection = !clickObj.item.isShowSection;
        return;
      }
      handleClickItem(clickObj);
    };

    // 阿里直播
    const aliPlayer = ref();
    const aliPlayerCanPlay = (player) => {
      aliPlayer.value = player;
    };

    let showOne = ref(true);
    let showPoster = ref(false);
    const toShare = async () => {
      if (hbCodeUrl.value) {
        showPoster.value = true;
        await nextTick();
        if (showOne.value) {
          generateImg();
        }
        setUserShareType("pePoster");
      } else {
        Toast("分享失败");
      }
    };

    // 记录生成海报的用户 utype(用户分享行为)：pePoster:海报，peShare：分享
    const setUserShareType = (type) => {
      let userinfo = store.state.user.userinfo;
      let url =
        userinfo && userinfo.userId
          ? `${location.href}&utype=${type}&userid=${userinfo.userId}`
          : `${location.href}&utype=${type}`;
      setUserViewsRecords({
        linkKey: type,
        linkUrl: url,
      });
    };

    let imgbox = ref(null);
    let imgUrl = ref("");
    let imgStyleObj = ref({});
    // 生成图片
    const generateImg = async () => {
      const computedStyle = imgbox.value.getBoundingClientRect();
      html2canvas(imgbox.value, {
        useCORS: true,
        allowTaint: true,
        scale: window.devicePixelRatio,
        width: computedStyle.width,
        height: computedStyle.height,
      }).then(function (canvas) {
        imgStyleObj.value = {
          width: computedStyle.width + "px",
          height: computedStyle.height + "px",
        };
        imgUrl.value = canvas.toDataURL("image/png");
        showOne.value = false;
      });
    };

    let hbCodeUrl = ref("");
    // 生成二维码
    const generateQrCode = async () => {
      let shareUrl = window.location.origin;
      let userinfo = store.state.user.userinfo;
      let themeitem = theme;
      if (patientEducationId.value) {
        hbCodeUrl.value = await QRCode.toDataURL(
          `${shareUrl}/patienteducationdetail?patientEduId=${patientEducationId.value}&userid=${userinfo.userId}&_origin_=${themeitem}&utype=pePoster`
        );
      } else {
        hbCodeUrl.value = "";
      }
    };

    // 推荐视频
    const showRecommend = ref(false);
    const nextPlayTime = ref(3);
    let nextPlayTimer = null;
    // 2024-1-12 取消自动播放
    /* const setPlayNextTimer = () => {
      nextPlayTimer = setTimeout(() => {
        if (nextPlayTime.value > 0) {
          nextPlayTime.value -= 1;
          setPlayNextTimer();
        } else {
          clearTimeout(nextPlayTimer);
          showRecommend.value = false;
          nextPlayTime.value = 3;
          router.replace({
            name: "PlayAuth",
            query: {
              id: recommendList.value[0].columnId,
            },
          });
        }
      }, 1000);
    }; */
    const recommendList = ref([]);
    const getRecommendList = async () => {
      const { results } = await getRecommendListBySize({
        columnId: zhuanlanId.value,
        size: 3,
      });
      recommendList.value = results;
    };
    const closeRecommend = () => {
      // if (showRecommend.value) {
      //   clearTimeout(nextPlayTimer);
      //   showRecommend.value = false;
      //   nextPlayTime.value = 3;
      // }
      isCanLook.value = true;
      showRecommend.value = false;
    };
    const playRecommend = (id) => {
      closeRecommend();
      // 先跳去中转页面
      router.replace({
        name: "PlayAuth",
        // query: { id: id, _back_url: backUrl.value },
        query: { ...route.query, id },
      });
    };
    const handleReplay = (player) => {
      closeRecommend();
      currentTime.value = 0;
      player.replay();
    };

    // 记录取消兑换
    const duihuanSheetColse = () => {
      addPageBrowserRecord({
        linkKey: "h5-play-取消兑换",
        linkUrl: location.href,
      });
    };
    const commentsTotal = ref(0);
    const commentTitle = computed(() => {
      const str =
        commentsTotal.value == 0
          ? "讨论"
          : commentsTotal.value <= 99
          ? `讨论(${commentsTotal.value})`
          : "讨论(99+)";
      return str;
    });
    const updateCommentTitle = () => {
      commentsTotal.value += 1;
      lists.value = lists.value.map((item) => {
        if (item.type == 9) {
          item.name = commentTitle.value;
        }
        return item;
      });
    };
    // 获取留言条数
    getCommentsTotal(route.query.id).then((res) => {
      commentsTotal.value = res.results;
    });
    let rzForm = ref({});
    const surerzForm = async () => {
      if (idCard.value.length == 0) {
        Toast("请上传工作证");
        return;
      }
      rzForm.value = {
        name: name.value,
        idNumber: idNumber.value,
        trainer: trainer.value,
        workplace: workplace.value,
        department: keshimodel.value,
        departmentCode: departmentCode.value,
        departmentName: departmentName.value,
        idCard: idCard.value[0] ? idCard.value[0].url : "",
      };

      if (applyStatus.value == 1) {
        // 修改
        await updateApply(rzForm.value);
      } else {
        // 认证
        await addApply(rzForm.value);
      }
      // applyStatus.value = true;
      // // 重新获取活动数据
      // await handlerTabDetail(tabId.value, tabLists.value[0]);
      location.reload();
    };

    // 工作证
    let idCard = ref([]);
    const afterRead5 = async (file) => {
      idCard.value = [];
      let data = await oss.ossUploadImg(file);
      if (data) {
        const url = `https://ntppc.oss-cn-shanghai.aliyuncs.com/${data.fileUrl}`;
        idCard.value.push({ url: url });
      }
    };
    const delete5 = () => {
      idCard.value.length = 0;
    };
    // 登录
    let showLoginpop = ref(false);
    const tel = ref("");
    const code = ref("");
    let seconds = ref(120);
    let btnText = ref("获取验证码");
    const handleSendCode = async () => {
      if (seconds.value < 120) {
        return false;
      }
      if (!checkPhone(tel.value)) {
        Toast.fail("请输入正确的手机号");
      } else {
        try {
          const params = {
            phone: tel.value,
            source: await getCustomerServiceQrCode(theme),
            smsSource: theme,
          };
          await bindSendCode(params);
          Toast.success("验证码发送成功");
          // 定时器
          _timer();
        } catch (error) {
          console.error(error);
          Toast.fail("验证码发送失败");
        }
      }
    };

    const _timer = () => {
      let inter = setInterval(() => {
        seconds.value--;
        btnText.value = `${seconds.value}s后重新发送`;
        if (seconds.value <= 0) {
          clearInterval(inter);
          btnText.value = "获取验证码";
          seconds.value = 120;
        }
      }, 1000);
    };

    let btn_lock = false;
    const onSubmitLogin = async () => {
      if (btn_lock) {
        return false;
      }
      try {
        const params = {
          phone: tel.value,
          smsCode: code.value,
          source: await getCustomerServiceQrCode(theme),
          registerSource: theme,
          registerSourceUrl: "", // 页面
        };
        btn_lock = true;
        const { results } = await bindPhone(params);
        if (results.token) {
          let token = results.token.split(" ")[1];
          localStorage.setItem("token", token);
        }
        Toast.success("绑定成功");
        phone.value = tel.value;
        showLoginpop.value = false;
        // 重新获取活动数据
        // await handlerTabDetail(tabId.value, tabLists.value[0]);
        location.reload();
      } catch (error) {
        btn_lock = false;
        console.error(error);
        Toast.fail("绑定失败");
      }
    };

    const toMeetingList = async () => {
      let { results: code } = await tokenGetCode();
      const url = getJumpUrl("BASEHOME", {
        _code: code,
        _to_path: "meetinglist",
        _monitor_: "recommended_content",
      });
      location.replace(`${url}`);
    };

    const goToMeetingDetail = async (id) => {
      router.replace({
        name: "Play",
        query: {
          id: id,
          _re_content_: "recommended_content",
        },
      });
      setTimeout(() => {
        location.reload();
      });
    };

    // 点击底部聊天 -- 开始
    const livechatRef = ref(null);
    const replyLivechat = ref("");

    const handleLivechat = async () => {
      await nextTick();
      livechatRef.value.focus();
    };

    let prevHeight = document.documentElement.clientHeight;
    const preventDefault = (e) => {
      e.preventDefault();
    };

    const handleFocus = async () => {
      if (thisContentType.value == 20) {
        if (isAndroid()) {
          if (livechatTimer) {
            clearInterval(livechatTimer);
            livechatTimer = null;
          }
          console.log("安卓--升起键盘");
          prevHeight = document.documentElement.clientHeight;
          console.log(prevHeight);
          let dele = document.getElementsByClassName(
            "livechatroom-item-box"
          )[0];
          dele.style.minHeight = `${document.documentElement.clientHeight}px`;
          dele.style.paddingBottom = "100px";
          await nextTick();
          window.scrollTo(0, document.body.scrollHeight);
          await nextTick();
          const div = document.getElementsByClassName("lcr-list")[0];
          div.scrollTo(0, Math.ceil(div.scrollHeight) - div.clientHeight);
          await nextTick();
          window.addEventListener("touchmove", preventDefault, {
            passive: false,
          });
          onpenTime();
        } else if (isIOS()) {
          console.log("ios升起键盘了");
          if (livechatTimer) {
            clearInterval(livechatTimer);
            livechatTimer = null;
          }
          let dele = document.getElementsByClassName(
            "livechatroom-item-box"
          )[0];
          dele.style.paddingBottom = "40px";
          const div = document.getElementsByClassName("lcr-list")[0];
          div.scrollTo(
            0,
            Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
          );
          await nextTick();
          window.addEventListener("touchmove", preventDefault, {
            passive: false,
          });
          onpenTime();
        }
      }
    };

    const handleBlur = async () => {
      if (thisContentType.value == 20) {
        if (isAndroid()) {
          console.log("安卓--收起键盘");

          let dele = document.getElementsByClassName(
            "livechatroom-item-box"
          )[0];
          dele.style.minHeight = `0`;
          dele.style.paddingBottom = "10px";
          await nextTick();
          window.removeEventListener("touchmove", preventDefault);
          const div = document.getElementsByClassName("lcr-list")[0];
          div.scrollTo(
            0,
            Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
          );
        } else if (isIOS()) {
          console.log("ios升起收起");
          let dele = document.getElementsByClassName(
            "livechatroom-item-box"
          )[0];
          dele.style.paddingBottom = "10px";
          await nextTick();
          window.removeEventListener("touchmove", preventDefault);
          const div = document.getElementsByClassName("lcr-list")[0];
          div.scrollTo(
            0,
            Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
          );
        }
      }
    };

    const handleResize = async () => {
      if (thisContentType.value == 20) {
        const currentHeight = document.documentElement.clientHeight;
        if (currentHeight < prevHeight) {
          if (livechatTimer) {
            clearInterval(livechatTimer);
            livechatTimer = null;
          }
          console.log("窗口变化：安卓--升起键盘");
          let dele = document.getElementsByClassName(
            "livechatroom-item-box"
          )[0];
          dele.style.minHeight = `${document.documentElement.clientHeight}px`;
          dele.style.paddingBottom = "100px";
          await nextTick();
          window.scrollTo(0, document.body.scrollHeight);
          await nextTick();
          const div = document.getElementsByClassName("lcr-list")[0];
          div.scrollTo(
            0,
            Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
          );
          await nextTick();
          window.addEventListener("touchmove", preventDefault, {
            passive: false,
          });
          onpenTime();
        } else {
          console.log("窗口变化：安卓--收起键盘");
          livechatRef.value.blur();
          let dele = document.getElementsByClassName(
            "livechatroom-item-box"
          )[0];
          dele.style.paddingBottom = "10px";
          dele.style.minHeight = `0`;
          await nextTick();
          window.removeEventListener("touchmove", preventDefault);
          const div = document.getElementsByClassName("lcr-list")[0];
          div.scrollTo(
            0,
            Math.ceil(div.scrollHeight) - Math.ceil(div.clientHeight)
          );
        }
      }
    };

    // 点击底部聊天 -- 结束
    let chatList = ref([]);

    const getchatListInfo = async () => {
      let { results } = await getchatList({
        columnId: parseInt(zhuanlanId.value),
        lastId: chatList.value.length
          ? chatList.value[chatList.value.length - 1].id
          : "",
      });
      if (results.length) {
        results.forEach((item) => {
          let user = store.state.user.userinfo;
          const userId = user ? user.userId : "";

          if (item.userId == userId) {
            item.isMe = true;
          } else {
            item.isMe = false;
          }
        });
        chatList.value = chatList.value.concat(results);
      }
    };

    let livechat_lock = false;
    const onSubmitChat = async () => {
      if (replyLivechat.value === "") return Toast.fail("请输入聊天内容");
      if (livechat_lock) return;
      livechat_lock = true;

      if (livechatTimer) {
        clearInterval(livechatTimer);
        livechatTimer = null;
      }
      let { results } = await submitChat({
        columnId: parseInt(zhuanlanId.value),
        userChat: replyLivechat.value,
      });
      replyLivechat.value = "";
      await onpenTime();

      await nextTick();
      const div = document.getElementsByClassName("lcr-list")[0];
      div.scrollTo(0, div.scrollHeight - div.clientHeight);
      livechat_lock = false;
    };

    const totopChatUrl = () => {
      if (topChatUrl.value) {
        window.location.assign(topChatUrl.value);
      }
    };

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
      clearInterval(livechatTimer);
      livechatTimer = null;
    });

    return {
      showQuestion,
      toQuestion,
      code,
      tel,
      check6Code,
      seconds,
      btnText,
      showLoginpop,
      handleSendCode,
      onSubmitLogin,
      idCard,
      afterRead5,
      delete5,
      workplaceLabel,
      departmentLabel,
      sureInfotoRz,
      rzForm,
      surerzForm,
      showrzForm,
      isWx,
      setRight,
      shownewXs,
      showScoreTip,
      showScoreNew,
      scoreTip,
      videoDatas,
      timeupdateVideoDetails,
      zhuanlanId,
      lists,
      user,
      applyStatus,
      id,
      title,
      tabId,
      videoId,
      isVideo,
      isLive,
      showInfo1,
      showInfo2,
      showInfo3,
      showInfo1_video,
      showInfo2_video,
      showInfo3_video,
      showActivityInfo,
      showSuccess,
      showSignUp,
      activityForm,
      item,
      courses,
      lives,
      videoActiveIndex,
      liveActiveIndex,
      course,
      activeLive,
      liveId,
      liveUrls,
      text,
      activity,
      files,
      replyComment,
      isAnonymous,
      pageNo,
      pageSize,
      comments,
      status,
      total,
      tabLists,
      current,
      thisContentType,
      jianjie,
      liveErr,
      imgTextErr,
      descErr,
      fileErr,
      pageFrom,
      haveVideo,
      prevTab,
      userInfo: computed(() => store.state.user.userinfo),
      currentTime,
      showZhiboForm,
      originForm,
      form,
      rules2,
      needForm,
      formId,
      fromVal,
      showApplyInfo,
      showQRCode,
      showQRCodeMini,
      qrCodeUrl,
      isForce,
      isSubscribe,
      isForceSubscribe,
      clickVideo,
      clickVideoId,
      subscribeLevel,
      subscribeTimer,
      scene_id,
      userApply,
      showApplyInfo2,
      showInfo4_video,
      showInfo5_video,
      validPhone,
      timeupdateVideo,
      play,
      pause,
      ended,
      setInitDatas,
      powerHandle,
      tableHandle,
      forceHandle,
      setViewTimeFun,
      sureInfo,
      toBindPhone,
      sureInfo_video,
      sureActivityInfo,
      changeTab,
      signUp,
      quxiaobm,
      sureSignUp,
      submitFormFun,
      publishComment,
      handlePublishComment,
      getChildComments,
      getCommentListsFun,
      getMore,
      formatDataFun,
      publishCommentFun,
      handlerTabDetail,
      handleClickItem,
      handleClickLiveItem,
      handleClickFile,
      videoCollection,
      dealVideoViewNumFun,
      getUserStatusFun,
      toExercise,
      submitFormFun2,
      getZhiboModel,
      toShow,
      sureInfo1,
      getUserPublic,
      getUserPublicStatus,
      getQRCodeUrl,
      generateQR,
      showPopAgain,
      showKFCode,
      closekfPop,
      closePop,
      showAddressPop,
      onFinish,
      loadeddata,
      onClickLeft,
      cityList,
      showDidian,
      cascaderValue,
      namStr,
      namStr_video,
      myTrainerName,
      whiteFlag,
      isKc,
      toScoreCenter,
      scrollNavbar,
      showTitleNavbar,
      showForm,
      name,
      idNumber,
      phone,
      isFirst,
      trainer,
      trainerModel,
      workplace,
      keshimodel,
      departmentName,
      rejectReason,
      onSubmitForm,
      showzhiye,
      showkeshi,
      trainerArr,
      depementList,
      onConfirmZhiye,
      onConfirmdept,
      departmentCode,
      showZjAll,
      showZhuanjia,
      toJiangshi,
      author,
      isCanLook,
      videoBanner,
      showZhiboSign,
      toSignZhibo,
      showTime,
      zbyyTime,
      showTimeFlag,
      zbyyStatus,
      showDyCode,
      toYyzhibo,
      activityDialogVisible,
      activityDialogInfo,
      activityDialogSubmit,
      ggList,
      ggTimer,
      closeVideoGg,
      closeGg,
      toLink,
      videoGgList,
      internalInstance,
      showGgpop,
      ggPopUrl,
      toVideoGg,
      handleClickImg,
      qjggDatas,
      toLinkOther,
      miniprogramRenderArr,
      theme,
      showShiKanFlag,
      disableProgress,
      freeTime,
      collectFeeStatus,
      payStatus,
      secondSpecialName,
      checkIdNumber,
      courseCredits,
      handleExchange,
      exchangeModalVisible,
      confirmExchange,
      showExchangeBox,
      activeSectionId,
      goSectionTimeNode,
      secondContentLoading,
      updateCurrentClick,
      myIsShare,
      openShare,
      showBackNavarBar,
      showNavarBar,
      aliPlayerCanPlay,
      syncFlag,
      showPoster,
      showOne,
      hbCodeUrl,
      imgUrl,
      imgStyleObj,
      toShare,
      imgbox,
      wechatAccountSourceName,
      canAppoint,
      nextPlayTime,
      showRecommend,
      recommendList,
      playRecommend,
      handleReplay,
      duihuanSheetColse,
      userTotalValidPoints,
      commentsTotal,
      source,
      backUrl,
      showXiTi,
      xitiNo,
      showXitiList,
      onConfirmStlx,
      showAnswer,
      checkboxItemChange,
      toMeetingList,
      moreMeetingList,
      goToMeetingDetail,
      showMeetContentId,
      yuyueQrCode,
      handleFocus,
      handleBlur,
      livechatRef,
      replyLivechat,
      handleLivechat,
      onSubmitChat,
      chatList,
      addLength,
      toLast,
      topChat,
      totopChatUrl,
      isCollect,
      onSC,
    };
  },
});
</script>

<style lang="less" scoped>
.arrow-left {
  font-size: 18px !important;
}
.over-page {
  overflow: hidden;
}
.play-wrapper {
  box-sizing: border-box;
  height: 100%;
  padding-bottom: 50px;
  background: #ffffff;
  :deep(.van-popup) {
    .van-picker {
      .van-picker__confirm {
        color: #0f3cc6;
      }
    }
  }
  .flex {
    display: flex;
  }

  .flex-a-c {
    align-items: center;
  }

  .flex-j-c {
    justify-content: center;
  }

  .flex-j-b {
    justify-content: space-between;
  }

  .sticky {
    // position: sticky;
    // top: 0;
    // z-index: 99;
  }

  // top-视频
  .video-box {
    background: #ffffff;
    position: relative;

    .video-wrap {
      height: 212px;
      position: relative;
      .video {
        width: 100%;
        height: 212px;
      }
    }

    .content {
      padding: 14px 16px 16px 16px;

      .title {
        font-size: 14px;
        font-weight: 500;
        color: #212224;
        line-height: 20px;
        .sc {
          align-items: start;
          flex-shrink: 0;
          margin-left: 24px;
          margin-top: 3px;
          .icon {
            width: 12px;
            height: 12px;
            margin-right: 4px;
            background: url(./../../assets/H5/play/icon-sc.png) no-repeat 0 0;
            background-size: contain;
            margin-top: 3px;
          }
          .sc-text {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 18px;
          }
          &.active {
            .icon {
              background: url(./../../assets/H5/play/icon-sc-ed.png) no-repeat 0
                0;
              background-size: contain;
            }
            .sc-text {
              color: #feb432;
            }
          }
        }
      }
      .zhuanjia-box {
        margin-top: 12px;
        .img {
          box-sizing: border-box;
          width: 40px;
          height: 40px;
          margin-right: 8px;
          border-radius: 50%;
          overflow: hidden;
          background: #f3f3f3;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .word {
          flex: 1;
          width: 0;
          .name {
            margin-bottom: 3px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: 20px;
            span {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              margin-left: 4px;
            }
          }
          .detail {
            box-sizing: border-box;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            position: relative;
            overflow: hidden;
            .icon {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              .word {
                width: 26px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: #0f3cc6;
                line-height: 17px;
                margin-right: 3px;
              }
              .icon-box {
                width: 12px;
                height: 12px;
              }
            }
            .w-item {
              width: 100%;
            }
          }
          .to {
            display: inline-block;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0f3cc6;
            line-height: 17px;
          }
        }
      }
    }
  }
  .mt8 {
    margin-top: 8px;
  }

  // top-直播
  .zhibo-box {
    background: #ffffff;
    .zb-box-con {
      height: 212px;
      position: relative;
    }

    .time-tip {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 90;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(3px);
      padding: 0 16px;
      box-sizing: border-box;
      // z-index: 9999;
      .tip1 {
        text-align: center;
        margin-top: 60px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        span {
          font-size: 12px;
          margin: 0 4px;
          color: rgb(236 147 5);
        }
      }
      .tip2 {
        text-align: center;
        margin-top: 6px;
        font-size: 30px;
        font-weight: 500;
        color: #ffffff;
        line-height: 42px;
        /deep/ span {
          margin: 0 16px 0 4px;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          &.s {
            margin-right: 0;
          }
        }
      }
      .tip3 {
        text-align: center;
        margin-top: 6px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
      }
      .tip-btn {
        width: 92px;
        height: 28px;
        background: #0f3cc6;
        border-radius: 16px;
        margin: 0 auto;
        margin-top: 20px;
        button {
          height: 100%;
          font-size: 12px;
        }
      }
      .tip-btn-over {
        width: 92px;
        height: 28px;
        background: #ffffff;
        border-radius: 16px;
        margin: 0 auto;
        margin-top: 20px;
        button {
          height: 100%;
          font-size: 12px;
          color: #999999 !important;
        }
      }
    }

    .zhibo-wrap {
      height: 212px;
      position: relative;
      overflow: hidden;

      #zhiboIframe {
        width: 375px;
        height: 212px;
        border: none;
        z-index: 80;
      }

      /deep/ .player-replace {
        width: 375px;
        height: 212px;
      }

      .gg-item {
        position: absolute;
        left: 0%;
        overflow: hidden;
        max-width: 375px;
        max-height: 212px;
        .close-gg {
          position: absolute;
          top: 5px;
          right: 5px;
          z-index: 1;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.15);
        }
        .gg-img {
          font-size: 0;
          overflow: hidden;
          /deep/ .van-image {
            font-size: 0;
            overflow: hidden;
          }
        }
      }
    }

    .content {
      padding: 14px 16px 16px 16px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #212224;
        line-height: 20px;
      }
      .zhuanjia-box {
        margin-top: 12px;
        .img {
          box-sizing: border-box;
          width: 40px;
          height: 40px;
          margin-right: 8px;
          border-radius: 50%;
          overflow: hidden;
          background: #f3f3f3;
          flex-shrink: 0;
        }
        .word {
          flex: 1;
          width: 0;
          .name {
            margin-bottom: 3px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: 20px;
            span {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              margin-left: 4px;
            }
          }
          .detail {
            box-sizing: border-box;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            position: relative;
            overflow: hidden;
            .icon {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              .word {
                width: 26px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: #0f3cc6;
                line-height: 17px;
                margin-right: 3px;
              }
              .icon-box {
                width: 12px;
                height: 12px;
              }
            }
            .w-item {
              width: 100%;
            }
          }
          .to {
            display: inline-block;
            font-size: 12px;
            margin-top: 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0f3cc6;
            line-height: 17px;
          }
        }
      }
    }
  }

  // top-图片
  .banner {
    background: #ffffff;
    /deep/ .van-image {
      display: block;
      min-height: 50px;
    }
    .content {
      padding: 14px 16px 16px 16px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #212224;
        line-height: 20px;
      }

      .learn-count {
        margin-top: 4px;
        line-height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.25);
        line-height: 17px;

        .icon {
          font-size: 18px;
          height: 26px;
        }
      }
      .zhuanjia-box {
        margin-top: 12px;
        .img {
          box-sizing: border-box;
          width: 40px;
          height: 40px;
          margin-right: 8px;
          border-radius: 50%;
          overflow: hidden;
          background: #f3f3f3;
          flex-shrink: 0;
        }
        .word {
          flex: 1;
          width: 0;
          .name {
            margin-bottom: 3px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: 20px;
            span {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              margin-left: 4px;
            }
          }
          .detail {
            box-sizing: border-box;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            position: relative;
            overflow: hidden;
            .icon {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              .word {
                width: 26px;
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                color: #0f3cc6;
                line-height: 17px;
                margin-right: 3px;
              }
              .icon-box {
                width: 12px;
                height: 12px;
              }
            }
            .w-item {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .to-home-page {
    width: 100%;
    display: flex;
    align-items: center;
    .to-text {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0f3cc6;
      line-height: 17px;
    }
    .arrow_right {
      width: 12px;
      height: 12px;
      margin-left: 3px;
      // background: url("@/assets/H5/play/arrow_right_blue.png") no-repeat;
      // background-size: cover;
    }
  }

  // 广告
  .gg-item {
    &.wz-center {
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%);
    }
    &.wz-b-center {
      bottom: 0 !important;
      left: 50% !important;
      transform: translateX(-50%);
    }
  }

  // 页签
  /deep/ .tabs-box {
    padding: 8px 0 1px 0;
    background: #f7f7f7;
    .van-tabs {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;

      &.van-tab--active {
        font-weight: 600;
      }
      .van-tabs__line {
        width: 22px;
        height: 4px;
      }
    }
    .tab-1 {
      height: 44px;
      background: #ffffff;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #222222;
      line-height: 44px;
      padding-left: 16px;
      max-width: 100%;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }

  // 页签-item
  .tab-box {
    padding: 10px 16px;

    // 直播
    &.zhibo-item-box {
    }

    // 直播聊天室
    &.livechatroom-item-box {
      height: calc(100vh - 390px);
      display: flex;
      flex-direction: column;
      position: relative;
      box-sizing: border-box;
      .top-info {
        max-width: 343px;
        border-radius: 20px;
        margin-bottom: 13px;
        padding: 0 16px;
        flex-shrink: 0;
        /deep/ .van-notice-bar__left-icon {
          font-size: 24px;
          margin-right: 6px;
          img {
            width: 40px;
            height: 24px;
          }
        }
      }
      .lcr-list {
        flex: 1;
        overflow-y: scroll;

        .lcr-new {
          position: absolute;
          right: 10px;
          bottom: 0px;
          color: #20ed49;
          padding: 5px 10px;
          font-size: 12px;
          background: #fff;
          box-shadow: 0 0 8px 4px #ddd;
          border-radius: 16px;
        }

        .lcr-item {
          margin: 10px 0;
          display: flex;

          .lcr-item-left {
            margin-right: 10px;
            .l-i-l-photo {
              flex-shrink: 0;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              overflow: hidden;
              img {
                width: 100%;
              }
            }
            // .l-i-l-name {
            //   font-size: 12px;
            //   font-weight: 500;
            //   color: #999;
            //   line-height: 18px;
            //   text-align: right;
            // }
            .l-i-l-content {
              font-size: 14px;
              font-weight: 600;
              color: #fff;
              line-height: 20px;
              max-width: 220px;
              word-break: break-all;
              background: #254ef4;
              border-radius: 8px;
              padding: 5px 10px;
            }
          }
          .lcr-item-right {
            .l-i-r-name {
              font-size: 12px;
              font-weight: 500;
              color: #999;
              line-height: 18px;
            }
            .l-i-r-content {
              font-size: 14px;
              font-weight: 600;
              color: #222;
              line-height: 20px;
              max-width: 220px;
              word-break: break-all;
              background: #ededed;
              border-radius: 8px;
              padding: 5px 10px;
            }
            .l-i-r-photo {
              flex-shrink: 0;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              overflow: hidden;
              img {
                width: 100%;
              }
            }
          }
          &.me {
            justify-content: end;
          }
        }
      }
      .keyboard-box {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        background: #fff;
        box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.05);
        padding: 10px 16px 20px;
        .input-box {
          padding: 5px 10px;
          border-radius: 17px;
          background: #f8f8f8;
        }
        /deep/.van-icon-guide-o {
          font-size: 22px;
        }
      }
    }

    // 视频
    &.course-item-box {
    }
    // 积分兑换相关
    .exchange-box {
      position: fixed;
      bottom: 5px;
      width: 343px;
      height: 40px;
      margin: auto;
      border-radius: 20px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      background-color: #e8eeff;
      .left,
      .right {
        width: 171px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      .left {
        img {
          width: 21px;
          height: 20px;
        }
      }

      .credits-num {
        margin-left: 12px;
        color: #0f3cc6;
        font-size: 16px;
        font-weight: 600;
      }
      .right {
        width: 172px;
        height: 40px;
        background: url("@/assets/H5/play/exchangebg.png") no-repeat top;
        background-size: 172px 40px;
        overflow: hidden;
        span {
          color: #fff;
          font-size: 14px;
        }
      }
    }
    // 习题
    &.xiti-item-box {
      padding-top: 0;
    }

    // 图文
    &.tuwen-item-box {
      /deep/ img {
        max-width: 100%;
      }
    }

    // 活动
    &.activity-item-box {
      /deep/ img {
        max-width: 100%;
      }
    }

    // 文件
    &.wenjian-item-box {
    }

    // 简介
    &.jianjie-item-box {
      /deep/ img {
        max-width: 100%;
      }
    }

    // 留言
    &.liuyan-item-box {
      .liuyan {
        .box {
          padding: 7px 15px;
          background-color: #f7f8fa;
          border-radius: 7px;
          margin-bottom: 10px;
          .textarea {
            width: 100%;
            height: 60px;
            border: none;
            background-color: #f7f8fa;
            resize: none;
            font-size: 14px;
            &::-webkit-input-placeholder {
              color: #999999;
              font-size: 14px;
            }
          }

          .tip {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            text-align: right;
          }
        }
        .comment-btns {
          margin-bottom: 19px;
          font-size: 13px;
          /deep/ .van-checkbox {
            .van-checkbox__icon {
              font-size: 16px;
            }
            .van-checkbox__label {
              margin-left: 5px;
              line-height: 34px;
              height: 33px;
            }
          }
          .reply-btn {
            width: 88px;
          }
        }
      }
    }
  }
  // 更多会议回看
  .more-meeting-box {
    padding: 0 16px 50px;
    border-top: 8px solid #f7f7f7;
    .m-m-title {
      justify-content: space-between;
      .t-l {
        font-weight: 500;
        font-size: 14px;
        color: #555555;
        line-height: 40px;
      }
      .m-m-to {
        .text {
          font-weight: 400;
          font-size: 12px;
          color: #b1b1b3;
          line-height: 40px;
        }
        .icon {
          margin-left: 2px;
          width: 12px;
          height: 12px;
          background: url("../../assets/H5/play/arrow-select.png") no-repeat 0 0;
          background-size: contain;
        }
      }
    }
    .m-m-item {
      padding: 16px 0;
      border-bottom: 1px solid #f5f5f7;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: none;
      }
      .item-img {
        flex-shrink: 0;
        width: 138px;
        height: 78px;
        overflow: hidden;
        font-size: 0;
        margin-right: 12px;
        border-radius: 8px;
        img {
          width: 138px;
          height: 78px;
          object-fit: cover;
        }
      }
      .item-info {
        flex-direction: column;
        justify-content: space-between;
        .info-title {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
        }
        .info-time {
          font-weight: 400;
          font-size: 12px;
          color: #b1b1b3;
          line-height: 17px;
        }
      }
    }
  }
  // 积分兑换内容
  .exchange-content {
    // height: 338px;
    .exchange-info {
      padding: 0 16px;
    }
    .info-item {
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      border-bottom: 1px solid #ebedf0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .tip {
        color: #999;
        margin: 0 16px 0 4px;
      }
      .exchang-goods {
        color: #222;
        font-weight: 600;
      }
      .credits-num {
        font-weight: 600;
        color: #ff5200;
      }
    }
    .exhange-desc {
      padding: 23px 16px 0;
      font-size: 12px;
      .desc-title {
        color: #222222;
        line-height: 20px;
      }
      .decs-detail {
        margin-top: 6px;
        color: #999;
        .detail-item {
          line-height: 23px;
        }
      }
    }
    .btn-box {
      height: 50px;
      margin: 20px 0 5px;
      padding: 5px 16px;
      .exchange-btn {
        background-color: #0f3cc6;
        border-radius: 20px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
  //form
  .pop-form {
    /deep/ .van-cell-group {
      max-height: 350px;
      overflow-y: scroll;
    }
  }
  .form-btn-box {
    border-top: 1px solid #f5f5f5;
    /deep/ .van-button {
      border: none;
    }
  }

  .rz-content {
    .rejectReason {
      font-size: 12px;
      color: red;
      padding: 4px 32px;
    }
    /deep/ .van-cell-group {
      max-height: 380px;
    }
    .form-btn-box {
      padding: 10px 16px 30px;
    }
  }

  .active-content {
    padding-bottom: 100px;
  }

  //活动按钮
  .active-btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    width: 100%;
    padding: 10px 30px 30px 30px;
    z-index: 999;
    box-sizing: border-box;
  }

  .activity-info-dialog {
    .box {
      padding: 10px 20px;
      .paperwork {
        color: #646566;
        text-align: center;
        font-size: 14px;
      }
      .img {
        margin-top: 20px;
      }
    }
  }

  // 习题
  .toExercise {
    padding: 12px 20px;
    border-radius: 4px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    margin-top: 10px;

    .image {
      margin-right: 13px;
    }
  }

  // 二维码
  .qrCode-pop {
    /deep/ .u-mode-center-box {
      overflow: visible !important;
    }

    .img-box {
      width: 161px;
      height: 161px;
      margin: 25px auto 20px auto;
    }

    .text-box {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #323233;
      line-height: 22px;
      text-align: center;

      .text2 {
        font-size: 14px;
        margin-bottom: 25px;
      }
    }

    /deep/ .uni-scroll-view-content {
      height: auto;
    }
  }

  // mini二维码
  .qrCode-pop-mini {
    position: fixed;
    right: 0;
    bottom: 120px;
    width: 44px;
    height: 36px;
    background: #6f9fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 100px 0px 0px 100px;
    z-index: 8;
    padding: 10px 13px 10px 14px;
    box-sizing: border-box;
  }

  /deep/ .gg-pop {
    background: transparent !important;
    .img-box {
      padding: 40px;
      text-align: center;
    }
  }

  // 积分相关
  .score-top-tip {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 36px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;
    z-index: 999;
    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
    }
    .btn {
      width: 52px;
      height: 24px;
      margin-left: 12px;
      .van-button {
        font-size: 12px;
        background: transparent;
      }
    }
    .close {
      .van-icon {
        font-size: 14px;
      }
    }
  }
  .score-bottom-tip {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;
    .icon {
      width: 51px;
      height: 53px;
      background: url(@/assets/H5/score/icon-play-score.png) no-repeat 0 0;
      background-size: contain;
      margin-bottom: 5px;
      margin-right: 8px;
    }
    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      span {
        color: rgb(246 197 77);
      }
    }
    .btn {
      width: 52px;
      height: 24px;
      margin-left: 13px;
      .van-button {
        font-size: 12px;
      }
    }
  }

  .kf-pop {
    position: fixed;
    bottom: 30px;
    z-index: 8;
    width: 50px;
    height: 56px;
    transition: 0.5s;
    .van-image {
      width: 50px;
      height: 56px;
    }
  }
  /deep/ .kf-dialog {
    &.van-dialog {
      overflow: visible;
    }
    .close {
      width: 22px;
      height: 22px;
      position: absolute;
      right: 0;
      top: -38px;
      .van-icon {
        font-size: 25px;
      }
    }
    .img-box {
      width: 200px;
      height: 200px;
      margin: 36px auto 16px auto;
      position: relative;
      .van-image {
        width: 200px;
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .text-box {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #323233;
      line-height: 20px;
      margin-bottom: 20px;
    }
  }

  /deep/ .dy-dialog {
    &.van-dialog {
      overflow: visible;
    }
    .close {
      width: 22px;
      height: 22px;
      position: absolute;
      right: 0;
      top: -38px;
    }
    .img-box {
      width: 200px;
      height: 200px;
      margin: 26px auto 8px auto;
    }
    .text-box {
      font-size: 14px;
      font-weight: 400;
      color: #323233;
      line-height: 20px;
      text-align: center;
      margin-bottom: 20px;
    }
  }

  /deep/ .form-pop {
    .van-dialog__content {
      padding: 10px 10px;
    }
    .btn {
      margin: 20px 0 10px 0;
    }
  }
  // 动态表单
  :deep(.active-form-sheet) {
    max-height: 592px;
    .van-cell-group {
      max-height: 300px;
      overflow-y: scroll;
      .van-cell {
        &:last-child {
          margin-bottom: 50px;
        }
      }
    }
  }
}
.sticky-navbar {
  position: sticky;
  top: 0;
}
.float-navbar {
  position: absolute;
  margin-top: 6px;
  margin-left: 11px;
  width: 32px;
  height: 32px;
  z-index: 999;
  .left-img {
    width: 32px;
    height: 32px;
  }
}
</style>
<style lang="less">
// 扩大可拖动范围
// .drag-dom {
//   /deep/ .xgplayer-inactive .xgplayer-miniplayer-drag {
//     display: block !important;
//     height: 100% !important;
//   }
//   /deep/.xgplayer-skin-default .xgplayer-miniplayer-drag .drag-handle {
//     width: 100%;
//     height: 100%;
//   }
// }

.xgplayer-start,
.xgplayer-loading {
  width: 40px !important;
  height: 40px !important;
  margin: -20px auto auto -20px !important;
  svg {
    width: 40px;
    height: 40px;
  }
}

.xgplayer-replay {
  svg {
    width: 40px;
    height: 40px;
  }
}

.xgplayer-enter-spinner {
  width: 40px !important;
  height: 40px !important;
}
.zbqd-dialog {
  padding: 20px;
  .text-box {
    padding: 50px;
    text-align: center;
    font-size: 16px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-from {
  opacity: 0;
}

.qjgg-pop {
  background: transparent;
  width: 100%;
  text-align: center;
  .img-box {
    display: inline-block;
    max-width: 100%;
    text-align: center;
    font-size: 0;
    margin-top: 50px;
    position: relative;
    .close-box {
      position: absolute;
      top: -30px;
      right: 0;
      width: 22px;
      height: 22px;
      font-size: 0;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    img {
      max-width: 100%;
    }
  }
}
#launch-btn {
  width: 100% !important;
  height: 100% !important;
  display: block;
}
.gg-pop-center {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  z-index: 100000;
  .mode {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
  }
  .pop-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 91.4%;
    text-align: center;
    font-size: 0;
  }
  .pop-img {
    position: relative;
    text-align: center;
    font-size: 0;
    // padding-top: 36px;
    max-width: 100%;
    display: inline-block;
    img {
      max-width: 100%;
    }
    .pop-close {
      position: absolute;
      top: -36px;
      right: 0;
      width: 20px;
      height: 20px;
      font-size: 0;
      img {
        width: 100%;
      }
    }
  }
}

.gg-pop-bottom {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 99999;
  .pop-box {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
    font-size: 0;
  }

  .pop-close {
    position: absolute;
    top: -36px;
    right: 16px;
    width: 20px;
    height: 20px;
    font-size: 0;
    img {
      width: 100%;
    }
  }
  .pop-img {
    position: relative;
    text-align: center;
    font-size: 0;
    max-width: 100%;
    display: inline-block;
    img {
      max-width: 100%;
    }
  }
}

@media screen and (min-width: 500px) {
  .gg-pop-center {
    .pop-box {
      width: 500px !important;
    }
  }
}

.share-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 990;
  background: rgba(0, 0, 0, 0.7);
  .text {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    line-height: 22px;
    text-align: center;
    &.text1 {
      margin-top: 95px;
    }
    &.text2 {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      display: flex;
      align-items: center;
      margin-top: 53px;
      justify-content: center;
      .t1 {
        margin-right: 10px;
      }
      .t2 {
        display: flex;
        align-items: center;
        .py {
          width: 12px;
          height: 11px;
          background: url(@/assets/H5/play/py.png) no-repeat 0 0;
          background-size: contain;
          margin: 0 6px;
        }
        .pyq {
          width: 12px;
          height: 12px;
          background: url(@/assets/H5/play/pyq.png) no-repeat 0 0;
          background-size: contain;
          margin: 0 6px;
        }
      }
    }
  }
  .jiantou {
    width: 65px;
    height: 166px;
    background: url(@/assets/H5/play/fxjt.png) no-repeat 0 0;
    background-size: contain;
    position: absolute;
    top: 4px;
    right: 22px;
  }
}
.hj-share-btn {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .icon {
    width: 12px;
    height: 12px;
    background: url(@/assets/H5/play/icon-share.png) no-repeat 0 0;
    background-size: contain;
    margin-right: 6px;
  }
  .text {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
  }
}

.share-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  z-index: 1000;
  &.show {
    top: 0;
  }
  &.hide {
    top: -200%;
  }
  .mark {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }
  .c-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .name {
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      .close {
        width: 20px;
        height: 20px;
        background: url(@/assets/H5/score/close.png) no-repeat 0 0;
        background-size: contain;
      }
    }
    .w-box {
      width: 343px;
      background: linear-gradient(
        316deg,
        #ffe1dc 0%,
        #fff9f8 34%,
        #ffffff 100%
      );
      border-radius: 8px;
      border: 1px solid #ffffff;
      padding: 24px;
      box-sizing: border-box;
      .imgs {
        width: 100%;
        font-size: 0;
        overflow: hidden;
        img {
          width: 100%;
          max-height: 392px;
        }
      }
      .infos {
        margin-top: 16px;
        display: flex;
        align-items: center;
        .ererma {
          flex-shrink: 0;
          width: 80px;
          height: 80px;
          border-radius: 8px;
          border: 1px solid #ffcfb1;
          margin-right: 12px;
          overflow: hidden;
          img {
            width: 100%;
            object-fit: contain;
          }
        }
        .texts {
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;
          .tip1 {
            color: #822500;
          }
          .tip2 {
            color: #222222;
          }
        }
      }
    }
    .fxtp {
      font-size: 0;
      overflow: hidden;
      border-radius: 8px;
    }
    .b-tip {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-top: 16px;
      text-align: center;
    }
  }
}
.ziliao {
  height: 52px;
  padding: 0 16px;
  margin-top: 24px;
  .title {
    font-size: 14px;
    color: #323233;
    margin-bottom: 8px;
  }
  .label {
    font-size: 12px;
    color: #969799;
  }
}
.upload {
  background: #fff;
  padding: 16px 16px 0 16px;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  .label {
    width: 87px;
    margin-right: 12px;
    font-size: 14px;
    color: #646566;
    span {
      color: red;
    }
  }
  .img {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 12px;
    .van-uploader__wrapper {
      display: flex;
      justify-content: center;
      .van-uploader__upload {
        margin: 0 0 10px 0;
      }
    }
    .name {
      width: 106px;
      font-size: 12px;
      color: #969799;
      text-align: center;
    }
  }
}

// 登录
.login-pop {
  .close-box {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 16px;
    height: 16px;
    background: url(@/assets/H5/my/close.png) no-repeat 0 0;
    background-size: contain;
  }
  .login-form {
    padding: 40px 16px 20px;
    .btn-box {
      margin: 15px 16px;
    }
    .info {
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      color: #666666;
      span {
        color: #6f9fff;
      }
    }
  }
}

.xiti-pop {
  top: 50% !important;
  &.qp-xiti-pop {
    transform: rotate(90deg) translate3d(-50%, -50%, 0) !important;
    transform-origin: 0 0;
  }
  .title {
    padding: 14px 0 12px;
    font-weight: 500;
    font-size: 16px;
    color: #444444;
    line-height: 22px;
    text-align: center;
  }
  .xiti-item {
    padding-top: 16px;
    .van-cell {
      flex-wrap: wrap;
      padding: 0 20px;
      .van-cell__title {
        margin: 0;
        width: 100%;
        margin-bottom: 20px;
        font-size: 14px;
        line-height: 18px;
        .check-title {
          font-weight: 500;
          font-size: 16px;
          color: #222222;
          line-height: 22px;
          .multi {
            font-weight: 400;
            font-size: 14px;
            color: #0f3cc6;
            line-height: 20px;
          }
        }
      }
    }
    .van-radio {
      padding-bottom: 16px;
      &:last-child {
        padding-bottom: 0;
      }
      .van-radio__icon {
        width: 17px;
        height: 17px;
        font-size: 0;
        .check-icon {
          width: 100%;
          height: 100%;
        }
      }
      .van-radio__label {
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 22px;
      }
    }

    .van-checkbox {
      padding-bottom: 16px;
      &:last-child {
        padding-bottom: 0;
      }
      .van-checkbox__icon {
        width: 17px;
        height: 17px;
        font-size: 0;
        .check-icon {
          width: 100%;
          height: 100%;
        }
      }
      .van-checkbox__label {
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 22px;
      }
    }
    .daan {
      .true-box {
        margin: 24px 20px 0;
        padding: 6px 10px;
        font-weight: 400;
        font-size: 14px;
        color: #39b44d;
        line-height: 24px;
        background: rgba(57, 180, 77, 0.1);
        border-radius: 4px;
        display: flex;
        align-items: center;
        .icon {
          width: 16px;
          height: 16px;
          background: url(@/assets/H5/play/icon-dui.png) no-repeat 0 0;
          background-size: cover;
          margin-right: 6px;
        }
      }
      .false-box {
        margin: 24px 20px 0;
        .false {
          margin-bottom: 12px;
          padding: 6px 10px;
          font-weight: 400;
          font-size: 14px;
          color: #e93429;
          line-height: 24px;
          background: rgba(233, 52, 41, 0.1);
          border-radius: 4px;
          display: flex;
          align-items: center;
          .icon {
            width: 16px;
            height: 16px;
            background: url(@/assets/H5/play/icon-cuo.png) no-repeat 0 0;
            background-size: cover;
            margin-right: 6px;
          }
        }
        .true-daan {
          margin: 0 10px;
          display: flex;
          .t1 {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            flex-shrink: 0;
          }
          .t2 {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: rgba(37, 78, 244, 1);
          }
        }
      }
    }
    .max-h {
      max-height: 320px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .btn {
      margin: 30px auto 24px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 44px;
      color: #fff;
      background: #254ef4;
      border-radius: 22px;
      width: 145px;
      height: 44px;
      &.no {
        background: rgba(37, 78, 244, 0.5);
      }
    }
  }
  &.qp-xiti-pop {
    .max-h {
      max-height: 176px;
    }
  }
}

.question-btn {
  margin-top: 10px;
  width: 120px;
  height: 30px;
  button {
    height: 100%;
    font-size: 12px;
  }
}
</style>
